/* eslint-disable no-case-declarations */

import React, { Component } from 'react'
import loader from '../loader.gif'
import logo from '../logo.gif'
import GovernmentInformation from './GovernmentInformation'
import Address from './Address'
import Contact from './Contact'
import HealthInformation from './HealthInformation'
import Sources from './Sources'
import PropTypes from 'prop-types'
import { emailCheck } from '../constants'
import submit from '../submit.gif'
import PGPersonalInformation from './PGPersonalInformation'
import PGEducationHistory from './PGEducationHistory'
import PGAcademicInterest from './PGAcademicInterest'
import PGEmergencyContact from './PGEmergencyContact'
import PGEnglishProficiency from './PGEnglishProficiency'
import PGProfessionalExams from './PGProfessionalExams'
import PGEmployment from './PGEmployment'
import PGMaritalStatus from './PGMaritalStatus'
import PGPolicies from './PGPolicies'
import PGAcademicSupport from './PGAcademicSupport'
import PGUploadDocuments from './PGUploadDocuments'

export default class Mains extends Component {
  constructor(props) {
    super(props)
    this.state = {
      saveProcessing: false,
      nextProcessing: false,
      acceptedPolicies: false,
      isBlocking: true,
      loading: true,
      pgProgramId: null,
      program: '',
      nationality: 1,
      countryData: [],
      email: '',
      fname: '',
      lName: '',
      mName: '',
      motherInfo: [],
      fatherInfo: [],
      guardianInfo: [],
      saved: false,
      count: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      showUploadPage: false,
      sections: [
        { name: 'Applicant Personal Information', open: false },
        { name: 'Education & Academic History', open: false },
        { name: 'Program of Study', open: false },
        { name: 'Official Identification', open: false },
        { name: 'Address', open: false },
        { name: 'Contact Information', open: false },
        { name: 'Emergency Contact', open: false },
        { name: 'English Proficiency Assessment', open: false },
        { name: 'Professional Examinations', open: false },
        { name: 'Source of Information', open: false },
        { name: 'Employment', open: false },
        { name: 'Marital Status', open: false },
        { name: 'Academic Support', open: false },
        { name: 'Policies & Declarations', open: false }
      ],
      activeSections: [
        { name: 'Applicant Personal Information', open: false },
        { name: 'Education & Academic History', open: false },
        { name: 'Program of Study', open: false },
        { name: 'Official Identification', open: false },
        { name: 'Address', open: false },
        { name: 'Contact Information', open: false },
        { name: 'Emergency Contact', open: false },
        { name: 'English Proficiency Assessment', open: false },
        { name: 'Professional Examinations', open: false },
        { name: 'Source of Information', open: false },
        { name: 'Employment', open: false },
        { name: 'Marital Status', open: false },
        { name: 'Academic Support', open: false },
        { name: 'Policies & Declarations', open: false }
      ],
      incompleteApplicationId: 0,
      selectedProgram: 0,
      addressType: 0,
      line1: '',
      line2: '',
      country: 0,
      city: 0,
      dateOfBirth: 0,
      countryOfBirth: 0,
      gender: 0,
      siblingFName: '',
      siblingMName: '',
      siblingLName: '',
      siblingTKHNumber: '',
      arabicData: [],
      contactInformation: [],
      educationHistory: [],
      entryTerm: 0,
      selectedUniversity: 0,
      selectedSecondUniversity: 0,
      selectedSecondProgram: 0,
      selectedSecondMajor: 0,
      selectedLevel: 0,
      selectedSecondLevel: 0,
      programOfStudyId: '',
      description: '',
      secondDescription: '',
      nationalIdNumber: '',
      passportNumber: '',
      passportCountry: 0,
      passportExpiry: '',
      policyError: '',
      testTypeError: '',
      color: 'red',
      personalInformation: {},
      errorPI: {},
      ai: {},
      errorAI: {},
      governmentInformation: {},
      errorGI: {},
      address: {},
      errorAdd: {},
      contactInformations: {},
      errorContact: {},
      parentsInformation: {},
      errorParent: {},
      guardianInformation: {},
      errorGuard: {},
      educationHistorys: {},
      errorEdu: {},
      testScores: {},
      testScoresProp: {},
      errorTest: [],
      errorAcad: {},
      healthInformation: {},
      errorHI: {},
      sources: {},
      errorSources: {},
      sourceInformation: {},
      undergraduate: null,
      graduate: null,
      fatherId: null,
      motherId: null,
      ahsd: null,
      ib: null,
      anata: null,
      igcse: null,
      gcse: null,
      otherSource: null,
      isFoundation:false,
      isPopup:false,
      preferredCampus:'',
      dormPlanInterest:false,
      /* PG-specific state */
      militaryStatus: '',
      pgEducationData: {},
      pgEmergencyContact: {},
      taughtInEnglish: '',
      pgEnglishTests: [],
      covAlumni: '',
      hasProfExam: false,
      profExams: [],
      pgEmploymentData: {},
      maritalStatus: '',
      academicSupport: '',
      academicSupportDetails: '',
      errorPGMilitary: '',
      errorPGEdu: {},
      errorPGEmergency: {},
      errorPGEnglish: {},
      errorPGEmployment: {}
    }
    this.toggleAccordion = this.toggleAccordion.bind(this)
    this.toggleAll = this.toggleAll.bind(this)
    this.collectState = this.collectState.bind(this)
    this.prepareState = this.prepareState.bind(this)
    this.conditionCheck = this.conditionCheck.bind(this)
    this.personalInformationCheck = this.personalInformationCheck.bind(this)
    this.educationHistoryCheck = this.educationHistoryCheck.bind(this)
    this.academicInterestCheck = this.academicInterestCheck.bind(this)
    this.governmentInformationCheck = this.governmentInformationCheck.bind(this)
    this.addressCheck = this.addressCheck.bind(this)
    this.contactCheck = this.contactCheck.bind(this)
    this.parentsInformationCheck = this.parentsInformationCheck.bind(this)
    this.guardianInformationCheck = this.guardianInformationCheck.bind(this)
    this.testScoresCheck = this.testScoresCheck.bind(this)
    this.healthInformationCheck = this.healthInformationCheck.bind(this)
    this.sourcesCheck = this.sourcesCheck.bind(this)
    this.handleSave = this.handleSave.bind(this)
    this.submit = this.submit.bind(this)
    this.getDefaultValue = this.getDefaultValue.bind(this)
    this.changeFoundation=this.changeFoundation.bind(this)
    this.changePopup=this.changePopup.bind(this)
  }

  async componentDidMount() {
    // Fetch PG program ID from API config (not hardcoded)
    fetch(`${process.env.REACT_APP_API_URL}/api/login/GetPGProgramId`)
      .then(res => res.text())
      .then(res => { this.setState({ pgProgramId: parseInt(res) || null }) })
      .catch(() => {})

    this.setState({
      incompleteApplicationId: parseInt(this.props.incompleteApplicationId) || parseInt(sessionStorage.getItem('id')),
      token: this.props.token || sessionStorage.getItem('token') || sessionStorage.getItem('token')
    })
    fetch(`${process.env.REACT_APP_API_URL}/api/login/getprefilleddata`, {
      method: 'POST',
      body: JSON.stringify({
        IncompleteApplicationId: this.props.incompleteApplicationId || parseInt(sessionStorage.getItem('id')),
        Token: this.props.token || sessionStorage.getItem('token') || sessionStorage.getItem('token')
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })

      .then(res => res.json())
      .then(res => {
        if (res.StatusCode === 200) {

          this.setState({

            /* Personal Information */
            fName: res.data.FirstName,
            lName: res.data.LastName,
            mName: res.data.MiddleName,
            email: res.data.Email,
            dateOfBirth: res.data.DateOfBirth,
            countryOfBirth: res.data.CountryOfBirth,
            nationality: res.data.Nationality,
            gender: res.data.Gender,
            arabicData: res.data.ArabicData,
            siblingFName: res.data.SiblingFName,
            siblingMName: res.data.SiblingMName,
            siblingLName: res.data.SiblingLName,
            siblingTKHNumber: res.data.SiblingTKHNumber,
            personalInformation: {
              fName: res.data.FirstName,
              lName: res.data.LastName,
              mName: res.data.MiddleName,
              dateOfBirth: res.data.DateOfBirth,
              selectedCountry: res.data.CountryOfBirth,
              selectedNationality: res.data.Nationality,
              selectedGender: res.data.Gender,
              siblingFName: res.data.SiblingFName,
              siblingMName: res.data.SiblingMName,
              siblingLName: res.data.SiblingLName,
              siblingTKHNumber: res.data.SiblingTKHNumber,
              arabicText1: res.data.ArabicData && res.data.ArabicData.length >= 1 ? res.data.ArabicData[0].ColumnValue : '',
              arabicText2: res.data.ArabicData && res.data.ArabicData.length >= 2 ? res.data.ArabicData[1].ColumnValue : '',
              arabicText3: res.data.ArabicData && res.data.ArabicData.length >= 3 ? res.data.ArabicData[2].ColumnValue : '',
            },
            /* Contact Information */
            contactInformation: res.data.ContactInformation,
            /* Program of Study */

            selectedProgram: res.data.ProgramId,
            description: res.data.Description,
            secondDescription: res.data.SecDescription,
            entryTerm: res.data.EntryTerm,
            programOfStudyId: res.data.ProgramOfStudyId,
            selectedUniversity: res.data.UniversityId,
            selectedSecondUniversity: res.data.SecondUniversityId,
            selectedSecondProgram: res.data.SecondProgramId,
            selectedSecondMajor: res.data.SecondMajorId,
            selectedLevel: res.data.Level,
            selectedSecondLevel: res.data.SecondLevel,
            preferredCampus: res.data.PreferredCampus,
            pgSchoolName: res.data.PgSchoolName || '',
            /* Address */
            addressType: res.data.AddressTypeId,
            line1: res.data.Line1,
            line2: res.data.Line2,
            country: res.data.Country,
            city: res.data.City,
            region: res.data.StateProvinceId,
            dormPlanInterest: res.data.DormPlanInterest || false,
            address: {
              addressType: res.data.AddressTypeId,
              addressLine1: res.data.Line1,
              addressLine2: res.data.Line2,
              selectedCountry: res.data.Country,
              selectedCity: res.data.City,
              selectedRegion: res.data.StateProvinceId,
              dormPlanInterest: res.data.DormPlanInterest || false
            },
            /* Parents Information */
            fatherInfo: res.data.FatherInfo,
            motherInfo: res.data.MotherInfo,
            /* Guardian Information */
            guardianInfo: res.data.GuardianInfo,
            /* Government Information */
            nationalIdNumber: res.data.NationalIdNumber,
            passportNumber: res.data.PassportNumber,
            passportCountry: res.data.PassportCountryIssued,
            passportExpiry: res.data.PassportExpirationDate,
            governmentInformation: {
              passportNumber: res.data.PassportNumber,
              passportCountry: res.data.PassportCountryIssued,
              passportExpiryDate: res.data.PassportExpirationDate,
              nationalNumber: res.data.NationalIdNumber
            },
            /* Education*/
            educationHistory: res.data.EducationHistory,
            /* Test Section */
            testScoresProp: res.data.Tests,
            /* Health Information */
            hasBeenIll: res.data.HasBeenIll,
            illnessDescription: res.data.IllnessDescription,
            healthInformation: {
              illness: res.data.IllnessDescription || '',
              hasIllness: res.data.HasBeenIll || false
            },
            /* Sources */
            sources: res.data.ApplicationTestSourceId,
            otherSource: res.data.OtherSource,
            /* PG Fields */
            pgEnglishTests: res.data.Tests ? res.data.Tests.map(t => ({ test: t.Test, testType: t.TestType, score: t.Score, dateTaken: t.DateTaken ? t.DateTaken.split('T')[0] : '' })) : [{ test: '', testType: '', score: '', dateTaken: '' }],
            militaryStatus: res.data.MilitaryStatus || '',
            maritalStatus: res.data.MaritalStatus || '',
            academicSupport: res.data.AcademicSupport || '',
            academicSupportDetails: res.data.AcademicSupportDetails || '',
            covAlumni: res.data.CovAlumni || '',
            taughtInEnglish: res.data.BachelorTaughtInEnglish === 'true' ? 'Yes' : res.data.BachelorTaughtInEnglish === 'false' ? 'No' : '',
            hasProfExam: res.data.HasProfExam === 'true',
            profExams: res.data.PgProfExamsData ? JSON.parse(res.data.PgProfExamsData) : [],
            pgEmploymentData: {
              employmentStatus: res.data.EmploymentStatus || '',
              companyName: res.data.EmployerCompanyName || '',
              position: res.data.EmployerPosition || '',
              startDate: res.data.EmployerStartDate || '',
              briefOfDuties: res.data.EmployerDuties || '',
              employerIdNumber: res.data.EmployerIdNumber || ''
            },
            pgEmergencyContact: {
              relationship: res.data.PgEmergencyContactRelationship || '',
              givenName: res.data.PgEmergencyContactGivenName || '',
              middleName: res.data.PgEmergencyContactMiddleName || '',
              familyName: res.data.PgEmergencyContactFamilyName || '',
              mobileNumber: res.data.PgEmergencyContactMobile || '',
              emailAddress: res.data.PgEmergencyContactEmail || ''
            },
            pgEducationData: {
              bachelorUniversity: res.data.PgBachelorUniversity || '',
              bachelorUniversityName: res.data.PgBachelorUniversityName || '',
              bachelorDegree: res.data.PgBachelorDegree || '',
              bachelorFieldOfStudy: res.data.PgBachelorFieldOfStudy || '',
              bachelorYearOfGrad: res.data.PgBachelorYearOfGrad || '',
              hasAcademicAward: res.data.PgHasAcademicAward || '',
              covGraduate: res.data.CovAlumni || '',
              coventryId: res.data.CoventryId || '',
              academicAwards: res.data.PgAcademicAwards
                ? (() => {
                    try { return JSON.parse(res.data.PgAcademicAwards) } catch (e) {
                      // Legacy pipe-delimited format: type/institution/year/description|...
                      return res.data.PgAcademicAwards.split('|').map(entry => {
                        const p = entry.split('/')
                        return { type: p[0] || '', institution: p[1] || '', year: p[2] || '', description: p[3] || '' }
                      })
                    }
                  })()
                : null
            },
            sourceInformation: { ...this.state.sourceInformation, otherSource: res.data.OtherSource },
            /* Policies */
            acceptedPolicy: res.data.AcceptedPolicies,
            /* Id */
            undergraduate: res.data.UndergraduateId/*  1 */,
            fatherId: res.data.FatherId,
            motherId: res.data.MotherId,
            graduate: res.data.GraduateId /* ? res.data.GraduateId : 3 */
          })
          /*if (res.data.EducationHistory) {
            if (res.data.EducationHistory.length === 1) {
              const defaultVal = {
                CurriculumId: 0,
                EndDate: '0001-01-01T00:00:00',
                //EndDate:'',
                InstitutionName: null,
                CountryId: 0,
                GPA: 0.0,
                InstitutionId: 0,
                TranferedInstitutionName: null,
                TranferedInstitutionId: 0
              }
              if (JSON.stringify(defaultVal) === JSON.stringify(res.data.EducationHistory[0])) this.setState({ educationHistory: null })
            }
          }*/

        } else {
          this.setState({ error: 'Some Network Error Occured. Try again later. ' })
        }
      })
      .then(() => fetch(`${process.env.REACT_APP_API_URL}/api/PersonalInfo/GetCountries`))
      .then(res => res.json())
      .then(res => {
        if (res.length) {
          this.prepareState()
          this.setState({ countryData: res, loading: false })
        } else {
          this.setState({ error: 'Something wrong on our end. Please try again later.' })
        }
      })
      .catch(err => {
        this.setState({ loading: false, error: 'Some Network Error Occured. Try again later' })
        console.log(err)
      })
    window.addEventListener('beforeunload', this.unloadEvent)
    // Expose save function globally for session timeout auto-save
    window.__appSave = this.handleSave
  }

  unloadEvent(e) {
    // Allow navigation when redirecting to PayTabs payment page
    if (window.__payTabsRedirecting) return
    e.preventDefault()
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.unloadEvent)
  }

  prepareState() {
    const {
      selectedUniversity,
      selectedSecondUniversity,
      selectedSecondProgram,
      selectedSecondMajor,
      selectedLevel,
      selectedSecondLevel,
      entryTerm,
      selectedProgram,
      programOfStudyId,
      description,
      secondDescription,
      guardianInfo,
      fatherInfo,
      motherInfo,
      contactInformation,
      email,
      educationHistory,
      sources,
      undergraduate,
      fatherId,
      motherId,
      otherSource,
      testScoresProp,
      preferredCampus,
      pgSchoolName
    } = this.state
    // Program of Study
    const data = {
      selectedUniversity: selectedUniversity,
      selectedSecondUniversity: selectedSecondUniversity,
      selectedSecondProgram: selectedSecondProgram,
      selectedSecondMajor: selectedSecondMajor,
      selectedEntryTerm: entryTerm,
      selectedProgram: selectedProgram,
      selectedMajor: programOfStudyId,
      description: description,
      secondDescription: secondDescription,
      selectedLevel: selectedLevel,
      selectedSecondLevel: selectedSecondLevel,
      preferredCampus:preferredCampus,
      selectedSchool: pgSchoolName || ''
    }
    this.setState({ ai: data })
    // Guardian Information
    if (guardianInfo) {
      this.setState({
        guardianInformation: {
          guardianRelationship: guardianInfo.RelationType,
          guardianPrefix: guardianInfo.RelationPrefix,
          guardianFName: guardianInfo.RelationFirstName,
          guardianMName: guardianInfo.RelationMiddleName,
          guardianLName: guardianInfo.RelationLastName,
          guardianProfession: guardianInfo.Profession,
          guardianPhone: guardianInfo.MobileNumber,
          guardianEmail: guardianInfo.RelationEmail,
          guardianAddress: guardianInfo.GuardianAddress
        }
      })
    }
    /* PG form uses 13-step accordion (Upload Docs is a separate page after Next) */
    const pgSections = [
      { name: 'Applicant Personal Information', open: false },
      { name: 'Education & Academic History', open: false },
      { name: 'Program of Study', open: false },
      { name: 'Official Identification', open: false },
      { name: 'Address', open: false },
      { name: 'Contact Information', open: false },
      { name: 'Emergency Contact', open: false },
      { name: 'English Proficiency Assessment', open: false },
      { name: 'Professional Examinations', open: false },
      { name: 'Source of Information', open: false },
      { name: 'Employment', open: false },
      { name: 'Marital Status', open: false },
      { name: 'Academic Support', open: false },
      { name: 'Policies & Declarations', open: false }
    ]
    this.setState({ activeSections: pgSections })
    // Parents Information
    if (fatherInfo && motherInfo) {
      this.setState({
        parentsInformation: {
          fatherPrefix: fatherInfo.RelationPrefix,
          motherPrefix: motherInfo.RelationPrefix,
          fatherRelation: fatherId,
          motherRelation: motherId,
          fatherFName: fatherInfo.RelationFirstName,
          motherFName: motherInfo.RelationFirstName,
          fatherMName: fatherInfo.RelationMiddleName,
          motherMName: motherInfo.RelationMiddleName,
          fatherLName: fatherInfo.RelationLastName,
          motherLName: motherInfo.RelationLastName,
          fatherProfession: fatherInfo.Profession,
          motherProfession: motherInfo.Profession,
          fatherCompany: fatherInfo.Company,
          motherCompany: motherInfo.Company,
          fatherCompanyAddress: fatherInfo.CompanyAddress,
          motherCompanyAddress: motherInfo.CompanyAddress,
          fatherPhone: fatherInfo.MobileNumber,
          motherPhone: motherInfo.MobileNumber,
          fatherEmail: fatherInfo.RelationEmail,
          motherEmail: motherInfo.RelationEmail,
          fatherAddress: fatherInfo.Address,
          motherAddress: motherInfo.Address,
          motherAttendedInstitution: motherInfo.AttendedInstitution,
          fatherAttendedInstitution: fatherInfo.AttendedInstitution,
          fatherDeceased: fatherInfo.Deceased,
          motherDeceased: motherInfo.Deceased,
          isFatherEmployee: fatherInfo.IsFatherTKHEmployee,
          fatherIdNumber:fatherInfo.FatherIdNumber,
          isMotherEmployee: motherInfo.IsMotherTKHEmployee,
          motherIdNumber:motherInfo.MotherIdNumber,
        }
      })
    } else if (fatherInfo) {
      this.setState({
        parentsInformation: {
          fatherPrefix: fatherInfo.RelationPrefix || '',
          motherPrefix: '',
          fatherRelation: fatherId,
          motherRelation: motherId,
          fatherFName: fatherInfo.RelationFirstName || '',
          motherFName: '',
          fatherMName: fatherInfo.RelationMiddleName || '',
          motherMName: '',
          fatherLName: fatherInfo.RelationLastName || '',
          motherLName: '',
          fatherProfession: fatherInfo.Profession || '',
          motherProfession: '',
          fatherCompany: fatherInfo.Company || '',
          motherCompany: '',
          fatherCompanyAddress: fatherInfo.CompanyAddress || '',
          motherCompanyAddress: '',
          fatherPhone: fatherInfo.MobileNumber || '',
          motherPhone: '',
          fatherEmail: fatherInfo.RelationEmail || '',
          motherEmail: '',
          fatherAddress: fatherInfo.Address || '',
          motherAddress: '',
          motherAttendedInstitution: false,
          fatherAttendedInstitution: fatherInfo.AttendedInstitution || false,
          fatherDeceased: fatherInfo.Deceased,
          motherDeceased: '',
          isFatherEmployee: fatherInfo.IsFatherTKHEmployee||false,
          fatherIdNumber:fatherInfo.FatherIdNumber,
          isMotherEmployee: false,
          motherIdNumber:'',
        }
      })
    } else if (motherInfo) {
      this.setState({
        parentsInformation: {
          fatherPrefix: '',
          motherPrefix: motherInfo.RelationPrefix,
          fatherRelation: fatherId,
          motherRelation: motherId,
          fatherFName: '',
          motherFName: motherInfo.RelationFirstName || '',
          fatherMName: '',
          motherMName: motherInfo.RelationMiddleName || '',
          fatherLName: '',
          motherLName: motherInfo.RelationLastName || '',
          fatherProfession: '',
          motherProfession: motherInfo.Profession || '',
          fatherCompany: '',
          motherCompany: motherInfo.Company || '',
          fatherCompanyAddress: '',
          motherCompanyAddress: motherInfo.CompanyAddress || '',
          fatherPhone: '',
          motherPhone: motherInfo.MobileNumber || '',
          fatherEmail: '',
          motherEmail: motherInfo.RelationEmail || '',
          fatherAddress: '',
          motherAddress: motherInfo.Address || '',
          motherAttendedInstitution: motherInfo.AttendedInstitution || false,
          fatherAttendedInstitution: false,
          fatherDeceased: '',
          motherDeceased: motherInfo.Deceased,
          isFatherEmployee:false,
          fatherIdNumber:'',
          isMotherEmployee: motherInfo.IsMotherTKHEmployee||false,
          motherIdNumber:motherInfo.MotherIdNumber,
        }
      })
    }
    // Contact Information
    if (contactInformation) {
      const newContactInfo = []
      contactInformation.forEach((element, i) => {
        newContactInfo.push({
          phoneType: element.PhoneType,
          phoneCountry: element.CountryId,
          phoneNumber: element.PhoneNumber,
          isPrimary: element.IsPrimary,
          id: i
        })
      })
      this.setState({
        contactInformations: {
          email: email,
          phoneNumberArray: newContactInfo
        }
      })
    }
    // Test Scores
    if (testScoresProp && testScoresProp.length > 0) {
      const testScores = []
      testScoresProp.forEach(element => {
        testScores.push({
          test: element.Test,
          testType: element.TestType,
          score: element.Score,
          dateTaken: element.DateTaken
        })
      })
      this.setState({ testScores: { ...this.state.testScores, tests: testScores } })
    }


    // Education
    if ([undergraduate, '', null, undefined, 0].indexOf(parseInt(selectedProgram)) === -1) {
      const data = []
      if (educationHistory && educationHistory.length > 1) {
        educationHistory.forEach((element, i) => {

          if (i <= educationHistory.length - 2) {

            data.push(
              {
                universityCertificate: element.CurriculumId,
                yearOfGraduation: element.EndDate,
                selectedCountry: element.CountryId,
                selectedCity: element.CityId,
                gpa: element.GPA,
                universityName: element.InstitutionId,
                institutionName: element.InstitutionName,
                educationGrade: element.EducationGrade
              }
            )
          } else {
            this.setState({
              educationHistorys: {
                graduateDegree: data,
                universityCertificate: element.CurriculumId,
                yearOfGraduation: element.EndDate,
                selectedCountry: element.CountryId,
                selectedCity: element.CityId,
                gpa: element.GPA,
                universityName: element.InstitutionId,
                institutionName: element.InstitutionName,
                educationGrade: element.EducationGrade
              }
            })
          }
        })
      } else if (educationHistory && educationHistory.length === 1) {

        const element = educationHistory[0]
        this.setState({
          educationHistorys: {
            graduateDegree: [],
            universityCertificate: element.CurriculumId,
            yearOfGraduation: element.EndDate,
            selectedCountry: element.CountryId,
            selectedCity: element.CityId,
            gpa: element.GPA,
            universityName: element.InstitutionId,
            institutionName: element.InstitutionName,
            educationGrade: element.EducationGrade
          }
        })
      }
    } else if (parseInt(selectedProgram) === undergraduate) {

      if (educationHistory && educationHistory.length > 1) {
        const data = []
        educationHistory.forEach((element, i) => {
          if (i <= educationHistory.length - 2) {
            data.push(
              {
                highSchoolCertificate: element.CurriculumId,
                endDate: element.EndDate,
                selectedCountry: element.CountryId,
                selectedCity: element.CityId,
                highSchoolName: element.InstitutionId,
                institutionName: element.InstitutionName,
                perviousUniversityName: element.TranferedInstitutionName,
                perviousUniversity: element.TranferedInstitutionId,
                previousUniversityCertificate: element.TransferredCerti,
                //previousUniversityMajor: element.TransferredMajor,
                previousUniversityGPA: element.TransferredGPA,
                educationGrade: element.EducationGrade,
                previousUniversityCountry:element.TransferCountryId,
                previousUniversityCity:element.TransferCityId,
              }
            )
          } else {
            this.setState({
              educationHistorys: {
                underGradDegree: data,
                highSchoolCertificate: element.CurriculumId,
                endDate: element.EndDate,
                selectedCountry: element.CountryId,
                selectedCity: element.CityId,
                highSchoolName: element.InstitutionId,
                institutionName: element.InstitutionName,
                perviousUniversityName: element.TranferedInstitutionName,
                perviousUniversity: element.TranferedInstitutionId,
                previousUniversityCertificate: element.TransferredCerti,
                //previousUniversityMajor: element.TransferredMajor,
                previousUniversityGPA: element.TransferredGPA,
                educationGrade: element.EducationGrade,
                previousUniversityCountry:element.TransferCountryId,
                previousUniversityCity:element.TransferCityId,
              }
            })
          }
        })
      } else if (educationHistory && educationHistory.length === 1) {

        const data = []
        const element = educationHistory[0]

        this.setState({
          educationHistorys: {
            underGradDegree: data,
            highSchoolCertificate: element.CurriculumId,
            endDate: element.EndDate,
            selectedCountry: element.CountryId,
            selectedCity: element.CityId,
            highSchoolName: element.InstitutionId,
            institutionName: element.InstitutionName,
            perviousUniversityName: element.TranferedInstitutionName,
            perviousUniversity: element.TranferedInstitutionId,
            previousUniversityCertificate: element.TransferredCerti,
            //previousUniversityMajor: element.TransferredMajor,
            previousUniversityGPA: element.TransferredGPA,
            educationGrade: element.EducationGrade,
            previousUniversityCountry:element.TransferCountryId,
            previousUniversityCity:element.TransferCityId,
          }
        })
      }
    } else {
      this.setState({ educationHistorys: {} })
    }

    // Sources
    const newSources = []
    if (sources) {
      sources.forEach(element => {
        newSources.push(element.Id)
      })
      this.setState({ sourceInformation: { selectedSources: newSources, otherSource: otherSource } })
    }
  }

  personalInformationCheck(personalInformation = this.state.personalInformation) {
    // const { personalInformation } = this.state;
    const errorCheck = [0, '', null, undefined, NaN, '0']
    const errorPI = {}
    if (personalInformation.fName
      && personalInformation.lName
      && personalInformation.mName
      && personalInformation.selectedCountry
      && personalInformation.selectedGender
      && personalInformation.dateOfBirth
      && (personalInformation.siblingTKHNumber.length === 0 || personalInformation.siblingTKHNumber.length === 9)
      && errorCheck.indexOf(personalInformation.selectedNationality) === -1 && personalInformation.selectedNationality !== 50) {
      //Sibling FN
      if (personalInformation.siblingFName) {

        if (!personalInformation.siblingLName) {
          errorPI.siblingLName = 'Please Enter Last Name'
        }
        if (!personalInformation.siblingTKHNumber) {
          errorPI.siblingTKHNumber = 'Please Enter TKH Number'
        }

        if (!personalInformation.siblingFName) {
          errorPI.siblingFName = 'Please Enter First Name'
        }

        if (!personalInformation.selectedCountry) {
          errorPI.selectedCountry = 'Please Enter Country of Birth'
        }

        if (!personalInformation.dateOfBirth) {
          errorPI.dateOfBirth = 'Please Enter Date Of Birth'
        }

        if (personalInformation.selectedNationality == 50) {
          if (!personalInformation.arabicText1) {
            errorPI.arabicText1 = 'Please Enter Arabic First Name'
          }
          if (!personalInformation.arabicText2) {
            errorPI.arabicText2 = 'Please Enter Arabic Middle Name'
          }
          if (!personalInformation.arabicText3) {
            errorPI.arabicText3 = 'Please Enter Arabic Last Name'
          }

          if (!personalInformation.arabicText1 || !personalInformation.arabicText2 || !personalInformation.arabicText3) {
            this.setState({ errorPI: errorPI })
            return 0
          }

          if (personalInformation.arabicText1 && personalInformation.arabicText2 && personalInformation.arabicText3) {
            this.setState({ errorPI: errorPI })
            return 1
          }
        }

        if (personalInformation.siblingTKHNumber && personalInformation.siblingLName) {
          this.setState({ errorPI: {} })
          return 1
        }


        else {
          if (!personalInformation.selectedCountry) {
            errorPI.selectedCountry = 'Please Enter Nationality'
          }

          if (!personalInformation.dateOfBirth) {
            errorPI.dateOfBirth = 'Please Enter Date Of Birth'
          }

          if (!personalInformation.countryOfBirth) {
            errorPI.countryOfBirth = 'Please Enter Country Of Birth'
          }

          if (!personalInformation.selectedGender) {
            errorPI.selectedGender = 'Please Enter Gender'
          }
        }

        this.setState({ errorPI: errorPI })
        return 0
      }

      //Sibling TKH
      if (personalInformation.siblingTKHNumber) {

        if (!personalInformation.siblingLName) {
          errorPI.siblingLName = 'Please Enter Last Name'
        }

        if (!personalInformation.siblingFName) {
          errorPI.siblingFName = 'Please Enter First Name'
        }

        if (!personalInformation.selectedCountry) {
          errorPI.selectedCountry = 'Please Enter Country of Birth'
        }

        if (!personalInformation.dateOfBirth) {
          errorPI.dateOfBirth = 'Please Enter Date Of Birth'
        }

        if (personalInformation.selectedNationality == 50) {
          if (!personalInformation.arabicText1) {
            errorPI.arabicText1 = 'Please Enter Arabic First Name'
          }
          if (!personalInformation.arabicText2) {
            errorPI.arabicText2 = 'Please Enter Arabic Middle Name'
          }
          if (!personalInformation.arabicText3) {
            errorPI.arabicText3 = 'Please Enter Arabic Last Name'
          }

          if (!personalInformation.arabicText1 || !personalInformation.arabicText2 || !personalInformation.arabicText3) {
            this.setState({ errorPI: errorPI })
            return 0
          }

          if (personalInformation.arabicText1 && personalInformation.arabicText2 && personalInformation.arabicText3) {
            this.setState({ errorPI: errorPI })
            return 1
          }
        }

        if (personalInformation.siblingLName && personalInformation.SiblingFName) {
          this.setState({ errorPI: {} })
          return 1
        }

        else {

          if (!personalInformation.selectedCountry) {
            errorPI.selectedCountry = 'Please Enter Nationality'
          }

          if (!personalInformation.dateOfBirth) {
            errorPI.dateOfBirth = 'Please Enter Date Of Birth'
          }

          if (!personalInformation.countryOfBirth) {
            errorPI.countryOfBirth = 'Please Enter Country Of Birth'
          }

          if (!personalInformation.selectedGender) {
            errorPI.selectedGender = 'Please Enter Gender'
          }
        }

        this.setState({ errorPI: errorPI })
        return 0
      }
      //Sibling LN
      if (personalInformation.siblingLName) {

        if (!personalInformation.siblingFName) {
          errorPI.siblingFName = 'Please Enter First Name'
        }

        if (!personalInformation.siblingTKHNumber) {
          errorPI.siblingTKHNumber = 'Please Enter TKH Number'
        }

        if (!personalInformation.selectedCountry) {
          errorPI.selectedCountry = 'Please Enter Country of Birth'
        }

        if (!personalInformation.dateOfBirth) {
          errorPI.dateOfBirth = 'Please Enter Date Of Birth'
        }

        if (personalInformation.selectedNationality == 50) {
          if (!personalInformation.arabicText1) {
            errorPI.arabicText1 = 'Please Enter Arabic First Name'
          }
          if (!personalInformation.arabicText2) {
            errorPI.arabicText2 = 'Please Enter Arabic Middle Name'
          }
          if (!personalInformation.arabicText3) {
            errorPI.arabicText3 = 'Please Enter Arabic Last Name'
          }

          if (!personalInformation.arabicText1 || !personalInformation.arabicText2 || !personalInformation.arabicText3) {
            this.setState({ errorPI: errorPI })
            return 0
          }

          if (personalInformation.arabicText1 && personalInformation.arabicText2 && personalInformation.arabicText3) {
            this.setState({ errorPI: errorPI })
            return 1
          }
        }

        if (personalInformation.siblingTKHNumber && personalInformation.SiblingFName) {
          this.setState({ errorPI: {} })
          return 1
        }

        else {

          if (!personalInformation.selectedCountry) {
            errorPI.selectedCountry = 'Please Enter Nationality'
          }

          if (!personalInformation.dateOfBirth) {
            errorPI.dateOfBirth = 'Please Enter Date Of Birth'
          }

          if (!personalInformation.countryOfBirth) {
            errorPI.countryOfBirth = 'Please Enter Country Of Birth'
          }

          if (!personalInformation.selectedGender) {
            errorPI.selectedGender = 'Please Enter Gender'
          }
        }

        this.setState({ errorPI: errorPI })
        return 0
      }


      if (personalInformation.selectedNationality == 50) {
        if (!personalInformation.arabicText1) {
          errorPI.arabicText1 = 'Please Enter Arabic First Name'
        }
        if (!personalInformation.arabicText2) {
          errorPI.arabicText2 = 'Please Enter Arabic Middle Name'
        }
        if (!personalInformation.arabicText3) {
          errorPI.arabicText3 = 'Please Enter Arabic Last Name'
        }

        if (!personalInformation.arabicText1 || !personalInformation.arabicText2 || !personalInformation.arabicText3) {
          this.setState({ errorPI: errorPI })
          return 0
        }

        if (personalInformation.arabicText1 && personalInformation.arabicText2 && personalInformation.arabicText3) {
          this.setState({ errorPI: errorPI })
          return 1
        }
      }


      this.setState({ errorPI: {} })
      return 1
    } else {
      const errorPI = {}
      let IsNotError=1
      if (!personalInformation.fName) {
        errorPI.fName = 'Please Enter First Name'
        IsNotError=0
      }
      if (!personalInformation.mName) {
        errorPI.mName = 'Please Enter Middle Name'
        IsNotError=0
      }
      if (!personalInformation.lName) {
        errorPI.lName = 'Please Enter Last Name'
        IsNotError=0
      }
      if (!(errorCheck.indexOf(personalInformation.selectedNationality) === -1)) {
        errorPI.selectedNationality = 'Please Select Nationality'
        IsNotError=0
      }
      if (!personalInformation.selectedCountry) {
        errorPI.selectedCountry = 'Please Enter Country of Birth'
        IsNotError=0
      }
      if (!personalInformation.selectedGender) {
        errorPI.selectedGender = 'Please Enter Gender'
        IsNotError=0
      }

      if (!personalInformation.dateOfBirth) {
        errorPI.dateOfBirth = 'Please Enter Date Of Birth'
        IsNotError=0
      }

      if(personalInformation.siblingFName)
      {
        if(!personalInformation.siblingLName)
        {
          errorPI.siblingLName = 'Please Enter Last Name'
          IsNotError=0
        }
        if(!personalInformation.siblingTKHNumber)
          {
            errorPI.siblingTKHNumber = 'Please Enter TKH Number'
            IsNotError=0
          }
      }


      if(personalInformation.SiblingTKHNumber)
      {
        if(!personalInformation.siblingLName)
        {
          errorPI.siblingLName = 'Please Enter Fisrt Name'
          IsNotError=0
        }
        if(!personalInformation.siblingFName)
          {
            errorPI.siblingFName = 'Please Enter Last Name'
            IsNotError=0
          }
      }

     if (personalInformation.siblingTKHNumber)
      { 
        if(personalInformation.siblingTKHNumber.length > 0 && personalInformation.siblingTKHNumber.length !== 9) {
          errorPI.siblingTKHNumber = 'Please enter exactly 9 numeric digits (0-9)'
          IsNotError=0
        }
     }

     if(personalInformation.selectedNationality == 50)
     {
       if (!personalInformation.arabicText1) {
         errorPI.arabicText1 = 'Please Enter Arabic First Name'
         IsNotError=0
       }
       if (!personalInformation.arabicText2) {
         errorPI.arabicText2 = 'Please Enter Arabic Middle Name'
         IsNotError=0
       }
       if (!personalInformation.arabicText3) {
         errorPI.arabicText3 = 'Please Enter Arabic Last Name'
         IsNotError=0
       }
       
       /*if(personalInformation.arabicText1 && personalInformation.arabicText2 && personalInformation.arabicText3 && personalInformation.mName)
       {
        this.setState({ errorPI: errorPI })
        return 1
       }*/
     }

      this.setState({ errorPI: errorPI })
      return IsNotError
    }
  }


  academicInterestCheck(ai = this.state.ai) {
    // Program of Study
    // const {
    //   ai
    // } = this.state
    const errorCheck = [0, '', null, undefined, NaN, '0']
    const errorAI = {}
    // preferredCampus is optional for PG (always '' in PG form) — only enforce when it IS provided
    // Level does not apply to PG (program 3) — no levels exist in ITB_UndergraduateProgramLevels for Graduate
    const isPG = this.state.pgProgramId && (ai.selectedProgram === this.state.pgProgramId || ai.selectedProgram === String(this.state.pgProgramId))
    const levelOk = isPG || errorCheck.indexOf(ai.selectedLevel) === -1
    if (errorCheck.indexOf(ai.selectedMajor) === -1 && levelOk && errorCheck.indexOf(ai.selectedUniversity) === -1 && errorCheck.indexOf(ai.selectedEntryTerm) === -1 && (errorCheck.indexOf(ai.preferredCampus) === -1 || !ai.preferredCampus)) {
      if ((errorCheck.indexOf(ai.selectedSecondUniversity) === -1) && (errorCheck.indexOf(ai.selectedSecondMajor) === -1)) {
        if (!(errorCheck.indexOf(ai.selectedSecondLevel) === -1) || !(errorCheck.indexOf(ai.selectedLevel) === -1)) {

          errorAI.selectedSecondLevel = 'Please Select Level'
          //  this.setState({ errorAI: errorAI })
          console.log(1)
          if (!(errorCheck.indexOf(ai.selectedLevel) === -1))
            errorAI.selectedLevel = 'Please Select Level'

          this.setState({ errorAI: errorAI })
          return 0

        }
      }
      this.setState({ errorAI: {} })
      return 1
    } else {
      // const errorAI = {}
      if (!(errorCheck.indexOf(ai.selectedUniversity) === -1)) {
        errorAI.selectedUniversity = 'Please Select University'
      }

      if (!(errorCheck.indexOf(ai.selectedMajor) === -1)) {
        errorAI.selectedMajor = 'Please Select Major'
      }

      if (!(errorCheck.indexOf(ai.selectedEntryTerm) === -1)) {
        errorAI.selectedEntryTerm = 'Please Select Entry Term'
      }
      if (!isPG && !(errorCheck.indexOf(ai.selectedLevel) === -1)) {
        errorAI.selectedLevel = 'Please Select Level'
      }
      if(!(errorCheck.indexOf(ai.preferredCampus) === -1)){
        errorAI.preferredCampus= 'Please Select Your Preferred Campus'
      }

      if ((errorCheck.indexOf(ai.selectedSecondUniversity) === -1) && (errorCheck.indexOf(ai.selectedSecondMajor) === -1)) {
        if (!(errorCheck.indexOf(ai.selectedSecondLevel) === -1)) {
          errorAI.selectedSecondLevel = 'Please Select Level'
        }
      }

      this.setState({ errorAI: errorAI })

      return 0
    }
  }

  governmentInformationCheck(governmentInformation = this.state.governmentInformation) {
    // Governmnpment Information
    const {
      personalInformation
    } = this.state
    const errorCheck = [0, '', null, undefined, NaN, '0']
    const errorGI = {}
    if (parseInt(personalInformation.selectedNationality) === 50) {
      if (governmentInformation.nationalNumber) {
        if (governmentInformation.nationalNumber.length === 14) {
          this.setState({ errorGI: {} })
          return 1
        }
        else {
          errorGI.nationalNumber = 'Please enter 14 numbers'
          this.setState({ errorGI: errorGI })
          return 0
        }
      }
      else {
        if (!governmentInformation.nationalNumber) {
          errorGI.nationalNumber = 'Please enter National ID Number'
        }
        else {
          if (governmentInformation.nationalNumber.length !== 14) {
            errorGI.nationalNumber = 'Please enter 14 numbers'
          }
        }

        this.setState({ errorGI: errorGI })
        return 0

      }
    }
    else {
      if (governmentInformation.passportNumber && governmentInformation.passportExpiryDate && errorCheck.indexOf(governmentInformation.passportCountry) === -1) {
        this.setState({ errorGI: {} })
        return 1
      } else {
        const errorGI = {}
        if (!governmentInformation.passportNumber) {
          errorGI.passportNumber = 'Please Enter Passport Number'
        }

        if (!governmentInformation.passportExpiryDate) {
          errorGI.passportExpiryDate = 'Please Enter Expiry Date'
        }

        if (!(errorCheck.indexOf(governmentInformation.passportCountry) === -1)) {
          errorGI.passportCountry = 'Please Select Country'
        }
        this.setState({ errorGI: errorGI })
        return 0
      }
    }
  }

  addressCheck(address = this.state.address) {
    // Address
    // const {
    //   address
    // } = this.state
    const errorCheck = [0, '', null, undefined, NaN, '0']
    if (errorCheck.indexOf(address.addressType) === -1 && address.addressLine1 && address.selectedCity && errorCheck.indexOf(address.selectedCountry) === -1 ) {
      this.setState({ errorAdd: {} })
      return 1
    } else {
      const errorAdd = {}
      if (!(errorCheck.indexOf(address.addressType) === -1)) {
        errorAdd.addressType = 'Please Select Address Type'
      }
      if (!address.addressLine1) {
        errorAdd.addressLine1 = 'Please Enter Address Line 1'
      }

      if (!(errorCheck.indexOf(address.selectedCountry) === -1)) {
        errorAdd.selectedCountry = 'Please Select Country'
      }

      if (!address.selectedCity) {
        errorAdd.selectedCity = 'Please Enter City'
      }

      this.setState({ errorAdd: errorAdd })
      return 0
    }
  }

  contactCheck(contactInformations = this.state.contactInformations) {
    // Contact Information
    // const {
    //   contactInformations
    // } = this.state
    const errorCheck = [0, '', null, undefined, NaN, '0']
    let countC = 0
    const errorContact = {}
    if (contactInformations.phoneNumberArray && contactInformations.phoneNumberArray.length >= 1) {
      contactInformations.phoneNumberArray.forEach((element, index) => {
        errorContact[index] = {}
        if (errorCheck.indexOf(element.phoneNumber) !== -1 || errorCheck.indexOf(element.phoneType) !== -1 || errorCheck.indexOf(element.phoneCountry) !== -1) {
          if (errorCheck.indexOf(element.phoneNumber) !== -1) {
            errorContact[index].phoneNumber = 'Please Enter Number'
          }
          if (errorCheck.indexOf(element.phoneType) !== -1) {
            errorContact[index].phoneType = 'Please Select Phone Type'
          }
          if (errorCheck.indexOf(element.phoneCountry) !== -1) {
            errorContact[index].phoneCountry = 'Please Select Country'
          }
          countC = 1
        }
      })
      if (countC === 0 && emailCheck.test(contactInformations.email)) {
        this.setState({ errorContact: {} })
        return 1
      } else {
        this.setState({ errorContact: errorContact })
        return 0
      }
    } else {
      errorContact[0] = {}
      errorContact[0].phoneNumber = 'Please Enter Number'
      errorContact[0].phoneType = 'Please Select Phone Type'
      errorContact[0].phoneCountry = 'Please Select Country'
      this.setState({ errorContact: errorContact })
      return 0
    }
  }

  parentsInformationCheck(parentsInformation = this.state.parentsInformation) {
    // Parents Information
    // const {
    //   parentsInformation
    // } = this.state
    const errorCheck = [0, '', null, undefined, NaN, '0']
    if (!parentsInformation.fatherDeceased && !parentsInformation.motherDeceased) {
      // check all fields
      if (errorCheck.indexOf(parentsInformation.fatherPrefix) === -1 && errorCheck.indexOf(parentsInformation.motherPrefix) === -1 && parentsInformation.fatherFName && parentsInformation.motherFName && parentsInformation.fatherMName && parentsInformation.motherMName && parentsInformation.fatherLName && parentsInformation.motherLName && parentsInformation.fatherProfession && parentsInformation.motherProfession && parentsInformation.fatherPhone && parentsInformation.motherPhone && parentsInformation.fatherEmail) {
        if ((emailCheck.test(parentsInformation.fatherEmail) || ['', null, undefined].indexOf(parentsInformation.fatherEmail) !== -1) &&
          (emailCheck.test(parentsInformation.motherEmail) || ['', null, undefined].indexOf(parentsInformation.motherEmail) !== -1)) {
            let ret=1
            let errorParent = {}
          if(parentsInformation.isFatherEmployee && ['', null, undefined].indexOf(parentsInformation.fatherIdNumber) !== -1)
          {
            errorParent.fatherIdNumber = 'Please Enter Your Father Id Number'
            ret=0
          }
          if(parentsInformation.isMotherEmployee && ['', null, undefined].indexOf(parentsInformation.motherIdNumber) !== -1)
          {
            errorParent.motherIdNumber = 'Please Enter Your Mother Id Number'
            ret=0
          }

          this.setState({ errorParent: errorParent})
          return ret
        } else {
          const errorParent = {}
          if (['', null, undefined].indexOf(parentsInformation.fatherEmail) === -1) {
            if (!emailCheck.test(parentsInformation.fatherEmail)) {
              errorParent.fatherEmail = 'Please Enter a Valid Email Address'
            }
          }
          if (['', null, undefined].indexOf(parentsInformation.motherEmail) === -1) {
            if (!emailCheck.test(parentsInformation.motherEmail)) {
              errorParent.motherEmail = 'Please Enter a Valid Email Address'
            }
          }
          this.setState({ errorParent: errorParent })
          return 0
        }
      } else {
        const errorParent = {}
        if (!(errorCheck.indexOf(parentsInformation.fatherPrefix) === -1)) {
          errorParent.fatherPrefix = 'Please Select Prefix'
        }
        if (!parentsInformation.fatherFName) {
          errorParent.fatherFName = 'Please Enter First Name'
        }
        if (!parentsInformation.fatherMName) {
          errorParent.fatherMName = 'Please Enter Middle Name'
        }
        if (!parentsInformation.fatherLName) {
          errorParent.fatherLName = 'Please Enter Last Name'
        }
        if (!parentsInformation.fatherProfession) {
          errorParent.fatherProfession = 'Please Enter Profession'
        }
        if (!parentsInformation.fatherPhone) {
          errorParent.fatherPhone = 'Please Enter Number'
        }

        if (!parentsInformation.fatherEmail) {
          errorParent.fatherEmail = 'Please Enter Email Address'
        }

        if (['', null, undefined].indexOf(parentsInformation.fatherEmail) === -1) {
          if (!emailCheck.test(parentsInformation.fatherEmail)) {
            errorParent.fatherEmail = 'Please Enter a Valid Email Address'
          }
        }
        if (!(errorCheck.indexOf(parentsInformation.motherPrefix) === -1)) {
          errorParent.motherPrefix = 'Please Select Prefix'
        }
        if (!parentsInformation.motherFName) {
          errorParent.motherFName = 'Please Enter First Name'
        }
        if (!parentsInformation.motherMName) {
          errorParent.motherMName = 'Please Enter Middle Name'
        }
        if (!parentsInformation.motherLName) {
          errorParent.motherLName = 'Please Enter Last Name'
        }
        if (!parentsInformation.motherProfession) {
          errorParent.motherProfession = 'Please Enter Profession'
        }
        if (!parentsInformation.motherPhone) {
          errorParent.motherPhone = 'Please Enter Number'
        }
        if (['', null, undefined].indexOf(parentsInformation.motherEmail) === -1) {
          if (!emailCheck.test(parentsInformation.motherEmail)) {
            errorParent.motherEmail = 'Please Enter a Valid Email Address'
          }
        }
        this.setState({ errorParent: errorParent })
        return 0
      }
    } else if (parentsInformation.fatherDeceased && parentsInformation.motherDeceased) {
      if ((emailCheck.test(parentsInformation.motherEmail) || ['', null, undefined].indexOf(parentsInformation.motherEmail) !== -1) &&
        (emailCheck.test(parentsInformation.fatherEmail) || ['', null, undefined].indexOf(parentsInformation.fatherEmail) !== -1)) {
        this.setState({ errorParent: {} })
        return 1
      } else {
        const errorParent = {}
        if (['', null, undefined].indexOf(parentsInformation.motherEmail) === -1) {
          if (!emailCheck.test(parentsInformation.motherEmail)) {
            errorParent.motherEmail = 'Please Enter a Valid Email Address'
          }
        }
        if (['', null, undefined].indexOf(parentsInformation.fatherEmail) === -1) {
          if (!emailCheck.test(parentsInformation.fatherEmail)) {
            errorParent.fatherEmail = 'Please Enter a Valid Email Address'
          }
        }
        this.setState({ errorParent: errorParent })
        return 0
      }
    } else if (!parentsInformation.motherDeceased && parentsInformation.fatherDeceased) {
      // check father email and mother all fields
      if (errorCheck.indexOf(parentsInformation.motherPrefix) === -1 && parentsInformation.motherFName && parentsInformation.motherMName && parentsInformation.motherLName && parentsInformation.motherProfession && parentsInformation.motherPhone) {
        if ((emailCheck.test(parentsInformation.fatherEmail) || ['', null, undefined].indexOf(parentsInformation.fatherEmail) !== -1) &&
          (emailCheck.test(parentsInformation.motherEmail) || ['', null, undefined].indexOf(parentsInformation.motherEmail) !== -1)) {
          this.setState({ errorParent: {} })
          return 1
        } else {
          const errorParent = {}
          if (['', null, undefined].indexOf(parentsInformation.fatherEmail) === -1) {
            if (!emailCheck.test(parentsInformation.fatherEmail)) {
              errorParent.fatherEmail = 'Please Enter a Valid Email Address'
            }
          }
          if (['', null, undefined].indexOf(parentsInformation.motherEmail) === -1) {
            if (!emailCheck.test(parentsInformation.motherEmail)) {
              errorParent.motherEmail = 'Please Enter a Valid Email Address'
            }
          }
          this.setState({ errorParent: errorParent })
          return 0
        }
      } else {
        const errorParent = {}
        if (!(errorCheck.indexOf(parentsInformation.motherPrefix) === -1)) {
          errorParent.motherPrefix = 'Please Select Prefix'
        }

        if (!parentsInformation.fatherEmail) {
          errorParent.fatherEmail = 'Please Enter Email Address'
        }

        if (!parentsInformation.motherFName) {
          errorParent.motherFName = 'Please Enter First Name'
        }
        if (!parentsInformation.motherMName) {
          errorParent.motherMName = 'Please Enter Middle Name'
        }
        if (!parentsInformation.motherLName) {
          errorParent.motherLName = 'Please Enter Last Name'
        }
        if (!parentsInformation.motherProfession) {
          errorParent.motherProfession = 'Please Enter Profession'
        }
        if (!parentsInformation.motherPhone) {
          errorParent.motherPhone = 'Please Enter Number'
        }


        if (!parentsInformation.fatherEmail) {
          errorParent.fatherEmail = 'Please Enter Email Address'
        }

        if (['', null, undefined].indexOf(parentsInformation.motherEmail) === -1) {
          if (!emailCheck.test(parentsInformation.motherEmail)) {
            errorParent.motherEmail = 'Please Enter a Valid Email Address'
          }
        }
        if (['', null, undefined].indexOf(parentsInformation.fatherEmail) === -1) {
          if (!emailCheck.test(parentsInformation.fatherEmail)) {
            errorParent.fatherEmail = 'Please Enter a Valid Email Address'
          }
        }
        this.setState({ errorParent: errorParent })
        return 0
      }
    } else if (!parentsInformation.fatherDeceased) {
      // check mother email and father all fields
      if (errorCheck.indexOf(parentsInformation.fatherPrefix) === -1 && parentsInformation.fatherFName && parentsInformation.fatherMName && parentsInformation.fatherLName && parentsInformation.fatherProfession && parentsInformation.fatherPhone) {
        if ((emailCheck.test(parentsInformation.motherEmail) || ['', null, undefined].indexOf(parentsInformation.motherEmail) !== -1) &&
          (emailCheck.test(parentsInformation.fatherEmail) || ['', null, undefined].indexOf(parentsInformation.fatherEmail) !== -1)) {
          this.setState({ errorParent: {} })
          return 1
        } else {
          const errorParent = {}
          if (['', null, undefined].indexOf(parentsInformation.motherEmail) === -1) {
            if (!emailCheck.test(parentsInformation.motherEmail)) {
              errorParent.motherEmail = 'Please Enter a Valid Email Address'
            }
          }
          if (['', null, undefined].indexOf(parentsInformation.fatherEmail) === -1) {
            if (!emailCheck.test(parentsInformation.fatherEmail)) {
              errorParent.fatherEmail = 'Please Enter a Valid Email Address'
            }
          }
          this.setState({ errorParent: errorParent })
          return 0
        }
      } else {
        const errorParent = {}
        if (!(errorCheck.indexOf(parentsInformation.fatherPrefix) === -1)) {
          errorParent.fatherPrefix = 'Please Select Prefix'
        }
        if (!parentsInformation.fatherFName) {
          errorParent.fatherFName = 'Please Enter First Name'
        }
        if (!parentsInformation.fatherMName) {
          errorParent.fatherMName = 'Please Enter Middle Name'
        }
        if (!parentsInformation.fatherLName) {
          errorParent.fatherLName = 'Please Enter Last Name'
        }
        if (!parentsInformation.fatherProfession) {
          errorParent.fatherProfession = 'Please Enter Profession'
        }
        if (!parentsInformation.fatherPhone) {
          errorParent.fatherPhone = 'Please Enter Number'
        }

        if (!parentsInformation.fatherEmail) {
          errorParent.fatherEmail = 'Please Enter Email Address'
        }

        if (parentsInformation.fatherEmail) {
          if (!emailCheck.test(parentsInformation.fatherEmail)) {
            errorParent.fatherEmail = 'Please Enter a Valid Email Address'
          }
        }
        if (parentsInformation.motherEmail) {
          if (!emailCheck.test(parentsInformation.motherEmail)) {
            errorParent.motherEmail = 'Please Enter a Valid Email Address'
          }
        }
        this.setState({ errorParent: errorParent })
        return 0
      }
    }
  }

  guardianInformationCheck(guardianInformation = this.state.guardianInformation) {
    // Guardian Information
    const {
      parentsInformation,
      fatherId,
      motherId
    } = this.state
    const errorCheck = [0, '', null, undefined, NaN, '0']

    if (['', null, undefined].indexOf(parentsInformation.motherEmail) === -1 &&
      ['', null, undefined].indexOf(guardianInformation.guardianEmail) !== -1) //if email address in the ParentMother's Info IS NOT NULL and NULL in the Guardian Info
    {
      guardianInformation.guardianEmail = parentsInformation.motherEmail;
    }

    if (errorCheck.indexOf(guardianInformation.guardianPrefix) === -1 && guardianInformation.guardianFName && guardianInformation.guardianEmail && guardianInformation.guardianMName && guardianInformation.guardianLName && guardianInformation.guardianProfession && guardianInformation.guardianPhone && guardianInformation.guardianAddress && guardianInformation.guardianRelationship !== '') {
      if ([fatherId].indexOf(parseInt(guardianInformation.guardianRelationship)) !== -1) {
        if (parentsInformation.fatherDeceased !== false) {
          this.setState({ errorGuard: { guardianRelationship: 'A deceased person cannot be a guardian' } })
          return 0
        } else {
          this.setState({ errorGuard: {} })
          return 1

        }
      } else if ([motherId].indexOf(parseInt(guardianInformation.guardianRelationship)) !== -1) {
        if (parentsInformation.motherDeceased !== false) {
          this.setState({ errorGuard: { guardianRelationship: 'A deceased person cannot be a guardian' } })
          return 0
        } else {
          if (['', null, undefined].indexOf(guardianInformation.guardianEmail) === -1) {
            if (emailCheck.test(guardianInformation.guardianEmail)) {
              this.setState({ errorGuard: {} })
            } else {
              this.setState({ errorGuard: { guardianEmail: 'Please Enter a Valid Email Address' } })
              return 0
            }
          } else {
            this.setState({ errorGuard: {} })
            return 1
          }
        }
      } else {
        if (['', null, undefined].indexOf(guardianInformation.guardianEmail) === -1) {
          if (emailCheck.test(guardianInformation.guardianEmail)) {
            this.setState({ errorGuard: {} })
            return 1
          } else {
            this.setState({ errorGuard: { guardianEmail: 'Please Enter a Valid Email Address' } })
            return 0
          }
        } else {
          this.setState({ errorGuard: {} })
          return 1
        }
      }
    } else {
      const errorGuard = {}
      if (!(errorCheck.indexOf(guardianInformation.guardianPrefix) === -1)) {
        errorGuard.guardianPrefix = 'Please Select Prefix'
      }
      if (!guardianInformation.guardianEmail) {
        errorGuard.guardianEmail = 'Please Enter Email Address'
      }
      if (!guardianInformation.guardianFName) {
        errorGuard.guardianFName = 'Please Enter First Name'
      }

      if (!guardianInformation.guardianMName) {
        errorGuard.guardianMName = 'Please Enter Middle Name'
      }
      if (!guardianInformation.guardianLName) {
        errorGuard.guardianLName = 'Please Enter Last Name'
      }
      if (!guardianInformation.guardianProfession) {
        errorGuard.guardianProfession = 'Please Enter Profession'
      }
      if (!guardianInformation.guardianPhone) {
        errorGuard.guardianPhone = 'Please Enter Number'
      }
      if (guardianInformation.guardianEmail) {
        if (!emailCheck.test(guardianInformation.guardianEmail)) {
          errorGuard.guardianEmail = 'Please Enter a Valid Email Address'
        }
      }
      if (!(errorCheck.indexOf(guardianInformation.guardianRelationship) === -1)) {
        errorGuard.guardianRelationship = 'Please Select Relationship'
      }

      if (!(errorCheck.indexOf(guardianInformation.guardianAddress) === -1)) {
        errorGuard.guardianAddress = 'Please Enter Address'
      }

      this.setState({ errorGuard: errorGuard })
      return 0
    }
  }

  educationHistoryCheck(educationHistorys = this.state.educationHistorys) {
    // Education
    const {
      ai,
      undergraduate
    } = this.state
    const errorCheck = [0, '', null, undefined, NaN, '0']
    if (parseInt(ai.selectedProgram) === undergraduate) {
      if (errorCheck.indexOf(educationHistorys.endDate) === -1 && errorCheck.indexOf(educationHistorys.highSchoolCertificate) === -1 && errorCheck.indexOf(educationHistorys.highSchoolName) === -1 && errorCheck.indexOf(educationHistorys.institutionName) === -1 && errorCheck.indexOf(educationHistorys.educationGrade) === -1 && errorCheck.indexOf(educationHistorys.selectedCountry) === -1 && errorCheck.indexOf(educationHistorys.selectedCity) === -1) {
        if (errorCheck.indexOf(educationHistorys.perviousUniversity) === -1) {
          if (educationHistorys.perviousUniversity === 'other') {
            if (!educationHistorys.perviousUniversityName) {
              const errorEdu = {}
              errorEdu.perviousUniversityName = 'Please enter university name'

              if (!educationHistorys.educationGrade) {
                errorEdu.educationGrade = 'Please Enter Grade'
              }

              /* if (!educationHistorys.previousUniversityGPA) {
                 errorEdu.previousUniversityGPA = 'Please Enter GPA'
               }
               if (!educationHistorys.previousUniversityCertificate) {
                 errorEdu.previousUniversityCertificate = 'Please Enter Certificate'
               }*/
              /* if (!educationHistorys.previousUniversityMajor) {
                 errorEdu.previousUniversityMajor = 'Please Enter Major'
               }*/
              this.setState({ errorEdu: errorEdu })
              return 0
            }

          }
          /* if (educationHistorys.previousUniversityGPA && educationHistorys.previousUniversityCertificate) {
             this.setState({ errorEdu: {} })
             return 1
           } else {
             const errorEdu = {}
             if (!educationHistorys.previousUniversityGPA) {
               errorEdu.previousUniversityGPA = 'Please Enter GPA'
             }
             if (!educationHistorys.previousUniversityCertificate) {
               errorEdu.previousUniversityCertificate = 'Please Enter Certificate'
             }
            if (!educationHistorys.previousUniversityMajor) {
               errorEdu.previousUniversityMajor = 'Please Enter Major'
             }
             this.setState({ errorEdu: errorEdu })
             return 0
           }*/
        } else {
          this.setState({ errorEdu: {} })
          return 1
        }
      } else if (educationHistorys.endDate === '' && educationHistorys.highSchoolCertificate === '' && educationHistorys.educationGrade === '' && educationHistorys.highSchoolName === '' && educationHistorys.selectedCountry === '' && educationHistorys.perviousUniversity === '' && educationHistorys.underGradDegree.length >= 1) {
        this.setState({ errorEdu: {} })
        return 1
      } else {
        const errorEdu = {}
        if (!(errorCheck.indexOf(educationHistorys.endDate) === -1)) {
          errorEdu.endDate = 'Please select end date'
        }
        if (!(errorCheck.indexOf(educationHistorys.highSchoolCertificate) === -1)) {
          errorEdu.highSchoolCertificate = 'Please Select High School Certificate'
        }
        if (!(errorCheck.indexOf(educationHistorys.highSchoolName) === -1)) {
          errorEdu.highSchoolName = 'Please select Name'
        }
        if (errorCheck.indexOf(educationHistorys.institutionName) !== -1 && educationHistorys.highSchoolName === '8') {
          errorEdu.institutionName = 'Please enter name'
        }
        if (errorCheck.indexOf(educationHistorys.selectedCountry) !== -1 && educationHistorys.highSchoolName === '8') {
          errorEdu.selectedCountry = 'Please select country'
        }
        if (errorCheck.indexOf(educationHistorys.selectedCity) !== -1 && educationHistorys.highSchoolName === '8') {
          errorEdu.selectedCity = 'Please select city'
        }
        if (!(errorCheck.indexOf(educationHistorys.educationGrade) === -1)) {
          errorEdu.educationGrade = 'Please Enter Grade'
        }
        if (errorCheck.indexOf(educationHistorys.perviousUniversity) === -1) {
          if (educationHistorys.perviousUniversity === 'other' && !educationHistorys.perviousUniversityName) {
            errorEdu.perviousUniversityName = 'Please enter university name'
          }
          if (educationHistorys.perviousUniversity === 'other' && errorCheck.indexOf(educationHistorys.previousUniversityCountry) !== -1) {
            errorEdu.previousUniversityCountry = 'Please select country'
          }
          if (educationHistorys.perviousUniversity === 'other' && errorCheck.indexOf(educationHistorys.previousUniversityCity) !== -1) {
            errorEdu.previousUniversityCity = 'Please select city'
          }
          /*  if (!educationHistorys.previousUniversityGPA) {
              errorEdu.previousUniversityGPA = 'Please Enter GPA'
            }
            if (!educationHistorys.previousUniversityCertificate) {
              errorEdu.previousUniversityCertificate = 'Please Enter Certificate'
            }*/

        }
        this.setState({ errorEdu: errorEdu })
        if (Object.keys(errorEdu).length === 0) {
          return 1
        } else {
          return 0
        }
      }
    } else if ([undergraduate, '', null, undefined, 0].indexOf(parseInt(ai.selectedProgram)) === -1) {
      if (errorCheck.indexOf(educationHistorys.universityCertificate) === -1 && errorCheck.indexOf(educationHistorys.institutionName) === -1 && educationHistorys.yearOfGraduation && errorCheck.indexOf(educationHistorys.universityName) === -1 && errorCheck.indexOf(educationHistorys.selectedCountry) === -1 && educationHistorys.gpa) {
        this.setState({ errorEdu: {} })
        return 1
      } else if (errorCheck.indexOf(educationHistorys.universityCertificate) !== -1 && educationHistorys.yearOfGraduation === '' && educationHistorys.gpa === '' && errorCheck.indexOf(educationHistorys.universityName) !== -1 && errorCheck.indexOf(educationHistorys.institutionName) !== -1 && errorCheck.indexOf(educationHistorys.selectedCountry) !== -1 && educationHistorys.graduateDegree.length >= 1) {
        this.setState({ errorEdu: {} })
        return 1
      } else {
        const errorEdu = {}
        if (!(errorCheck.indexOf(educationHistorys.universityCertificate) === -1)) {
          errorEdu.universityCertificate = 'Please Select Certificate'
        }
        if (!(errorCheck.indexOf(educationHistorys.yearOfGraduation) === -1)) {
          errorEdu.yearOfGraduation = 'Please Select Year of Graduation'
        }
        if (!(errorCheck.indexOf(educationHistorys.gpa) === -1)) {
          errorEdu.gpa = 'Please Select GPA'
        }
        if (!(errorCheck.indexOf(educationHistorys.universityName) === -1)) {
          errorEdu.universityName = 'Please Select University Name'
        }
        if (educationHistorys.universityName === 'other' && errorCheck.indexOf(educationHistorys.institutionName) !== -1) {
          errorEdu.institutionName = 'Please enter university name'
        }
        if (!(errorCheck.indexOf(educationHistorys.selectedCountry) === -1)) {
          errorEdu.selectedCountry = 'Please Select Country'
        }
        if (!(errorCheck.indexOf(educationHistorys.educationGrade) === -1)) {
          errorEdu.educationGrade = 'Please Enter Grade'
        }
        this.setState({ errorEdu: errorEdu })
        return 0
      }
    } else {
      this.setState({ errorEdu: {} })
      return 0
    }
  }

  testScoresCheck(testScores = this.state.testScores) {
    const errorCheck = [0, '', null, undefined, NaN, '0']
    if (testScores.tests && testScores.tests.length > 0) {
      const testArray = testScores.tests
      let count = 1
      const errorTest = []
      testArray.forEach((element, index) => {
        errorTest[index] = {}
        if (errorCheck.indexOf(element.test) !== -1 && errorCheck.indexOf(element.testType) !== -1 && errorCheck.indexOf(element.dateTaken) !== -1 && errorCheck.indexOf(element.score) !== -1) {
          errorTest[index] = {}
        } else if (errorCheck.indexOf(element.test) !== -1 || errorCheck.indexOf(element.testType) !== -1 || errorCheck.indexOf(element.dateTaken) !== -1 || errorCheck.indexOf(element.score) !== -1) {
          count = 0
          if (errorCheck.indexOf(element.test) !== -1) {
            errorTest[index].test = 'Please select test'
          }
          if (errorCheck.indexOf(element.testType) !== -1) {
            errorTest[index].testType = 'Please select test type'
          }
          if (errorCheck.indexOf(element.score) !== -1) {
            errorTest[index].score = 'Please enter score'
          }
          if (errorCheck.indexOf(element.dateTaken) !== -1) {
            errorTest[index].dateTaken = 'Please enter date taken'
          }
        }
      })

      //this test is for the Section Englist to light the section in red if not all the conditions is valid
      if (this.state.policyError.includes('English Proficiency Assessment') ||
        this.state.policyError.includes('Please enter all test type for the choosen test(s)')) {
        this.setState({ errorTest: errorTest })
        this.setState({ policyError: '' })
        
        return 0
      }
      if (count === 1) {
        this.setState({ errorTest: [] })
        return 1
      } else {
        console.log(1)
        this.setState({ errorTest: errorTest })
        return 0
      }
    } /* else {
      const errorTest = [{}]
      errorTest[0].test = 'Please select test'
      errorTest[0].testType = 'Please select test type'
      errorTest[0].score = 'Please enter score'
      errorTest[0].dateTaken = 'Please enter date taken'
      this.setState({ errorTest: errorTest })
      return 0
    } */
  }



  healthInformationCheck(healthInformation = this.state.healthInformation) {
    // Health Information
    // const {
    //   healthInformation
    // } = this.state
    if ((healthInformation.hasIllness || healthInformation.hasIllness === 'True') && healthInformation.illness) {
      this.setState({ errorHI: {} })
      return 1
    } else if (!healthInformation.hasIllness || healthInformation.hasIllness === 'False') {
      this.setState({ errorHI: {} })
      return 1
    } else {
      this.setState({ errorHI: { illness: 'Please fill required information' } })
      return 0
    }
  }

  sourcesCheck(sourceInformation = this.state.sourceInformation) {
    // Sources
    // const {
    //   sourceInformation
    // } = this.state
    // eslint-disable-next-line no-unused-vars
    const _unusedError = []
    if (sourceInformation.selectedSources && sourceInformation.selectedSources.length >= 1) {

      if (sourceInformation.selectedSources.includes(16) && (!sourceInformation.otherSource)) {
        this.setState({ errorSources: { general: 'Please Specify the other value.' } })
        return 0
      }
      else {
        this.setState({ errorSources: {} })
        return 1
      }

    } else {
      this.setState({ errorSources: { general: 'Please Select at-least one.' } })
      return 0
    }


  }

  conditionCheck() {
    const count = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    const { personalInformation, militaryStatus, pgEducationData, pgEmergencyContact,
      covAlumni, taughtInEnglish, pgEnglishTests, hasProfExam, pgEmploymentData,
      acceptedPolicies } = this.state

    // 0: Personal Information + Military Status (Egyptian males)
    const piResult = this.personalInformationCheck()
    const isEgyptianMale = parseInt(personalInformation.selectedNationality) === 50 && personalInformation.selectedGender === 'Male'
    if (piResult === 1 && isEgyptianMale && !militaryStatus) {
      this.setState({ errorPGMilitary: 'Please select military service status' })
      count[0] = 0
    } else {
      if (isEgyptianMale && militaryStatus) this.setState({ errorPGMilitary: '' })
      count[0] = piResult
    }

    // 1: Education & Academic History (PG — high school + bachelor sections required)
    const eduErrors = {}
    let eduOk = 1
    // High school section
    const hs = pgEducationData.highSchoolSection || {}
    if (!hs.highSchoolCertificate) { eduErrors.highSchoolCertificate = 'Required'; eduOk = 0 }
    if (!hs.endDate) { eduErrors.highSchoolEndDate = 'Required'; eduOk = 0 }
    if (!hs.highSchoolName) { eduErrors.highSchoolInstitutionId = 'Required'; eduOk = 0 }
    if (!hs.educationGrade) { eduErrors.educationGradeHS = 'Required'; eduOk = 0 }
    // Bachelor section
    if (!pgEducationData.bachelorUniversity) { eduErrors.bachelorUniversity = 'Required'; eduOk = 0 }
    if (!pgEducationData.bachelorDegree) { eduErrors.bachelorDegree = 'Required'; eduOk = 0 }
    if (!pgEducationData.bachelorFieldOfStudy) { eduErrors.bachelorFieldOfStudy = 'Required'; eduOk = 0 }
    if (!pgEducationData.bachelorYearOfGrad) { eduErrors.bachelorYearOfGrad = 'Required'; eduOk = 0 }
    if (!pgEducationData.covGraduate) { eduErrors.covGraduate = 'Required'; eduOk = 0 }
    // Academic awards (when hasAcademicAward === 'Yes')
    if (pgEducationData.hasAcademicAward === 'Yes' && pgEducationData.academicAwards) {
      pgEducationData.academicAwards.forEach((award, i) => {
        if (!award.type) { eduErrors[`awardType_${i}`] = 'Required'; eduOk = 0 }
        if (!award.institution) { eduErrors[`awardInstitution_${i}`] = 'Required'; eduOk = 0 }
        if (!award.year) { eduErrors[`awardYear_${i}`] = 'Required'; eduOk = 0 }
        if (award.type === 'Other' && !award.description) { eduErrors[`awardDescription_${i}`] = 'Required'; eduOk = 0 }
      })
    }
    this.setState({ errorPGEdu: eduErrors })
    count[1] = eduOk

    // 2: Program of Study
    count[2] = this.academicInterestCheck()

    // 3: Official Identification
    count[3] = this.governmentInformationCheck()

    // 4: Address
    count[4] = this.addressCheck()

    // 5: Contact Information
    count[5] = this.contactCheck()

    // 6: Emergency Contact
    const ecErrors = PGEmergencyContact.validate(pgEmergencyContact || {})
    this.setState({ errorPGEmergency: ecErrors })
    count[6] = Object.keys(ecErrors).length === 0 ? 1 : 0

    // 7: English Proficiency
    if (covAlumni === 'Yes' || covAlumni === true) {
      count[7] = 1 // Coventry alumni exempt
    } else if (!taughtInEnglish) {
      this.setState({ errorPGEnglish: { taughtInEnglish: 'Please answer this question' } })
      count[7] = 0
    } else if (taughtInEnglish === 'No') {
      const hasValidTest = pgEnglishTests && pgEnglishTests.length > 0 &&
        pgEnglishTests[0].test && pgEnglishTests[0].score && pgEnglishTests[0].dateTaken
      if (hasValidTest) { this.setState({ errorPGEnglish: {} }); count[7] = 1 }
      else { this.setState({ errorPGEnglish: { tests: 'Please provide at least one valid test score' } }); count[7] = 0 }
    } else {
      this.setState({ errorPGEnglish: {} })
      count[7] = 1
    }

    // 8: Professional Examinations (selection must be made — not blank)
    const profExamSelected = hasProfExam !== false || (this.state.profExams && this.state.profExams.length > 0)
    count[8] = profExamSelected ? 1 : 1 // not mandatory, always pass

    // 9: Source of Information
    count[9] = this.sourcesCheck()

    // 10: Employment
    const empErrors = PGEmployment.validate(pgEmploymentData || {})
    this.setState({ errorPGEmployment: empErrors })
    count[10] = Object.keys(empErrors).length === 0 ? 1 : 0

    // 11: Marital Status (optional)
    count[11] = 1

    count[12] = 1

    count[13] = acceptedPolicies ? 1 : 0

    this.setState({ count: count })
    return count
  }

  
  getActiveTabBody(i) {
    const {
    errorPI,
    errorAI,
    errorAdd,
    errorContact,
    errorGI,
    errorSources,
    ai,
    personalInformation,
    address,
    contactInformations,
    governmentInformation,
    sourceInformation,
    otherSource,
    incompleteApplicationId,
    acceptedPolicies,
    militaryStatus,
    errorPGMilitary,
    errorPGEdu,
    pgEmergencyContact,
    errorPGEmergency,
    covAlumni,
    taughtInEnglish,
    pgEnglishTests,
    hasProfExam,
    profExams,
    pgEmploymentData,
    errorPGEmployment,
    maritalStatus,
    academicSupport,
    academicSupportDetails,
    pgEducationData,
    educationHistory,
    countryData,
    dateOfBirth,
    countryOfBirth,
    nationality,
    gender,
    arabicData,
    fName,
    lName,
    mName,
    siblingFName,
    siblingMName,
    siblingLName,
    siblingTKHNumber,
    nationalIdNumber,
    passportNumber,
    passportCountry,
    passportExpiry,
    email,
    contactInformation
} = this.state
    let returnValue = '';
    const selectedSources = [];
    if (sourceInformation && sourceInformation.selectedSources && sourceInformation.selectedSources.length > 0) {
      sourceInformation.selectedSources.forEach(element => {
        selectedSources.push({ Id: element })
      })
    }
    
    switch (i) {
      case 0:
        // Personal Information
        returnValue = <PGPersonalInformation 
          countryData={countryData || 0}
          dateOfBirth={dateOfBirth || ''}
          countryOfBirth={countryOfBirth || 0}
          nationality={nationality || 0}
          gender={gender || ''}
          arabicData={arabicData || []}
          fName={fName}
          lName={lName}
          mName={mName}
          siblingFName={siblingFName || ''}
          siblingMName={siblingMName || ''}
          siblingLName={siblingLName || ''}
          siblingTKHNumber={siblingTKHNumber || ''}
          incompleteApplicationId={incompleteApplicationId}
          onSave={() => this.toggleAccordion(1)}
          collectState={this.collectState}
          error={errorPI}
          errorMilitary={errorPGMilitary}
          data={personalInformation}
          militaryStatus={militaryStatus}
        />
        break;
      case 1:
        // Education & Academic History
        returnValue = <PGEducationHistory
          incompleteApplicationId={incompleteApplicationId}
          error={errorPGEdu || {}}
          data={pgEducationData}
          educationHistory={educationHistory}
          collectState={this.collectState}
          onSave={() => this.toggleAccordion(2)}
        />
        break;
      case 2:
        // Program of Study
        returnValue = <PGAcademicInterest
          incompleteApplicationId={incompleteApplicationId}
          error={errorAI}
          data={ai}
          pgProgramId={this.state.pgProgramId}
          collectState={this.collectState}
          onSave={() => this.toggleAccordion(3)}
        />
        break;
      case 3:
        // Official Identification
        returnValue = <GovernmentInformation
          incompleteApplicationId={incompleteApplicationId}
          nationality={nationality || 0}
          countryData={countryData || []}
          nationalIdNumber={nationalIdNumber || ''}
          passportNumber={passportNumber || ''}
          passportCountry={passportCountry || 0}
          passportExpiry={passportExpiry || ''}
          militaryStatus={militaryStatus}
          error={errorGI || {}}
          collectState={this.collectState}
          onSave={() => this.toggleAccordion(4)}
        />
        break;
      case 4:
        // Address
        returnValue = <Address
          incompleteApplicationId={incompleteApplicationId}
          countryData={countryData || []}
          getDefaultValue={this.getDefaultValue}
          addressType={address.addressType}
          line1={address.addressLine1}
          line2={address.addressLine2}
          country={address.selectedCountry}
          city={address.selectedCity}
          stateProvinceId={address.selectedRegion}
          dormPlanInterest={address.dormPlanInterest}
          error={errorAdd || {}}
          collectState={this.collectState}
          onSave={() => this.toggleAccordion(5)}
        />
        break;
      case 5:
        // Contact Information
        returnValue = <Contact
          email={email || ''}
          contactInformation={contactInformation || []}
          countryData={countryData || []}
          getDefaultValue={this.getDefaultValue}
          incompleteApplicationId={incompleteApplicationId}
          collectState={this.collectState}
          error={errorContact || {}}
          onSave={() => this.toggleAccordion(6)}
        />
        break;
      case 6:
        // Emergency Contact
        returnValue = <PGEmergencyContact
          incompleteApplicationId={incompleteApplicationId}
          emergencyContactInfo={pgEmergencyContact}
          error={errorPGEmergency || {}}
          collectState={this.collectState}
          onSave={() => this.toggleAccordion(7)}
        />
        break;
      case 7:
        // English Proficiency Assessment
        returnValue = <PGEnglishProficiency
          incompleteApplicationId={incompleteApplicationId}
          tests={pgEnglishTests}
          taughtInEnglish={taughtInEnglish}
          covAlumni={covAlumni}
          error={{}}
          collectState={this.collectState}
          onSave={() => this.toggleAccordion(8)}
        />
        break;
      case 8:
        // Professional Examinations
        returnValue = <PGProfessionalExams
          incompleteApplicationId={incompleteApplicationId}
          profExams={profExams}
          collectState={this.collectState}
          onSave={() => this.toggleAccordion(9)}
          error={{}}
        />
        break;
      case 9:
        // Source of Information
        returnValue = <Sources
          incompleteApplicationId={incompleteApplicationId}
          sources={selectedSources || []}
          collectState={this.collectState}
          error={errorSources}
          otherSource={otherSource || null}
          onSave={() => this.toggleAccordion(10)}
        />
        break;
      case 10:
        // Employment
        returnValue = <PGEmployment
          incompleteApplicationId={incompleteApplicationId}
          error={errorPGEmployment || {}}
          employmentData={pgEmploymentData}
          collectState={this.collectState}
          onSave={() => this.toggleAccordion(11)}
        />
        break;
      case 11:
        // Marital Status
        returnValue = <PGMaritalStatus
          incompleteApplicationId={incompleteApplicationId}
          maritalStatus={maritalStatus}
          collectState={this.collectState}
          onSave={() => this.toggleAccordion(12)}
        />
        break;
      case 12:
        returnValue = <PGAcademicSupport
          incompleteApplicationId={incompleteApplicationId}
          academicSupport={academicSupport}
          academicSupportDetails={academicSupportDetails}
          collectState={this.collectState}
          onSave={() => this.toggleAccordion(13)}
        />
        break;
      case 13:
        returnValue = <PGPolicies
          incompleteApplicationId={incompleteApplicationId}
          acceptedPolicies={acceptedPolicies}
          collectState={this.collectState}
          onSave={() => this.toggleAccordion(13)}
        />
        break;
      default:
        returnValue = <p>Invalid Tab</p>
    }
    return <div className="accordionSectionBody">{returnValue}</div>;
  }

  changeFoundation(value)
{
  this.setState({isFoundation:value})
  
}
changePopup(value)
{
  if(value==true)
  this.setState({isPopup:value,preferredCampus:'West'})
  else if(value==false)
  this.setState({isPopup:value,preferredCampus:'East'})
  else if(value=='WestRemoved')
  this.setState({preferredCampus:'',selectedMajor:0,selectedLevel:0})
}

  collectState(componentName, data) {
    switch (componentName) {      case 'PI':
        this.setState({
          personalInformation: data,
          nationality: parseInt(data.selectedNationality) || 0,
          gender: data.selectedGender || ''
        })
        const { errorPI } = this.state
        const errorPIKeys = Object.keys(errorPI)
        if (errorPIKeys.length) {
          const returnValue = this.personalInformationCheck(data)
          if (returnValue === 1) {
            const count = Array.from(this.state.count)
            count[0] = 1
            this.setState({ count: count })
          }
        }
        break

      case 'EH':

        this.setState({ educationHistorys: data })
        const { errorEdu } = this.state
        const errorEduKeys = Object.keys(errorEdu)
        if (errorEduKeys.length) {
          const returnValue = this.educationHistoryCheck(data)

          if (returnValue === 1) {
            const count = Array.from(this.state.count)
            count[1] = 1
            this.setState({ count: count })
          }
        }
        break
      case 'AI':
        // eslint-disable-next-line no-unused-vars
        const accordionValue = this.state.activeSections[2] ? this.state.activeSections[2].open : false
        if (data.selectedProgram + '' !== this.state.ai.selectedProgram + '') {
          this.setState({ educationHistory: [], educationHistorys: {}, errorEdu: {}, selectedProgram: data.selectedProgram })
        }
        this.setState({ ai: data })
        const { errorAI } = this.state
        const errorAIKeys = Object.keys(errorAI)
        if (errorAIKeys.length) {
          const returnValue = this.academicInterestCheck(data)
          if (returnValue === 1) {
            const count = Array.from(this.state.count)
            count[2] = 1
            this.setState({ count: count })
          }
        }
        break

      /* ---- PG-specific collectState handlers ---- */
      case 'PG_Military':
        this.setState({ militaryStatus: data })
        break

      case 'PG_EH':
        this.setState({
          pgEducationData: data,
          covAlumni: data.covGraduate || ''
        })
        break

      case 'PG_EC':
        this.setState({ pgEmergencyContact: data })
        break

      case 'PG_EP':
        this.setState({
          taughtInEnglish: data.taughtInEnglish || '',
          pgEnglishTests: data.tests || []
        })
        break

      case 'PG_PE':
        this.setState({
          hasProfExam: data.hasProfExam || false,
          profExams: data.profExams || []
        })
        break

      case 'PG_Emp':
        this.setState({ pgEmploymentData: data })
        break

      case 'PG_Marital':
        this.setState({ maritalStatus: data })
        break
      case 'PG_AcademicSupport':
        this.setState({ academicSupport: data.academicSupport, academicSupportDetails: data.academicSupportDetails })
        break
      case 'GI':
        this.setState({ governmentInformation: data })
        const { errorGI } = this.state
        const errorGIKeys = Object.keys(errorGI)
        if (errorGIKeys.length) {
          const returnValue = this.governmentInformationCheck(data)
          if (returnValue === 1) {
            const count = Array.from(this.state.count)
            count[3] = 1
            this.setState({ count: count })
          }
        }
        break
      case 'Add':
        this.setState({ address: data })
        const { errorAdd } = this.state
        const errorAddKeys = Object.keys(errorAdd)
        if (errorAddKeys.length) {
          const returnValue = this.addressCheck(data)
          if (returnValue === 1) {
            const count = Array.from(this.state.count)
            count[4] = 1
            this.setState({ count: count })
          }
        }
        break
      case 'Contact':
        this.setState({ contactInformations: data })
        const { errorContact } = this.state
        let counts = 0
        const errorMainKeys = Object.keys(errorContact)
        if (errorMainKeys.length) {
          const returnValue = this.contactCheck(data)
          for (const element in errorContact) {
            if (Object.prototype.hasOwnProperty.call(errorContact, element)) {
              const errorContactKeys = Object.keys(element)
              if (errorContactKeys.length) {
                if (returnValue !== 1) {
                  counts = 1
                }
              }
            }
          }
          if (counts === 0) {
            const count = Array.from(this.state.count)
            count[5] = 1
            this.setState({ count: count })
          }
        }
        break
      case 'PSI':
        this.setState({ parentsInformation: data })
        const { errorParent } = this.state
        const errorParentKeys = Object.keys(errorParent)
        if (errorParentKeys.length) {
          const returnValue = this.parentsInformationCheck(data)
          if (returnValue === 1) {
            const count = Array.from(this.state.count)
            count[6] = 1
            this.setState({ count: count })
          }
        }
        break
      case 'Guardian':
        this.setState({ guardianInformation: data })
        const { errorGuard } = this.state
        const errorGuardKeys = Object.keys(errorGuard)
        if (errorGuardKeys.length) {
          const returnValue = this.guardianInformationCheck(data)
          if (returnValue === 1) {
            const count = Array.from(this.state.count)
            count[7] = 1
            this.setState({ count: count })
          }
        }
        break

      case 'TS':
        this.setState({ testScores: data })
        const { errorTest } = this.state
        /* const errorTestkeys = Object.keys(errorTest) */
        if (errorTest.length) {
          const returnValue = this.testScoresCheck(data)
          if (returnValue === 1) {
            const count = Array.from(this.state.count)
            count[8] = 1
            this.setState({ count: count })
          }
        }
        break
      case 'HI':
        this.setState({ healthInformation: data })
        const { errorHI } = this.state
        const errorHIKeys = Object.keys(errorHI)
        if (errorHIKeys.length) {
          const returnValue = this.healthInformationCheck(data)
          if (returnValue === 1) {
            const count = Array.from(this.state.count)
            count[9] = 1
            this.setState({ count: count })
          }
        }
        break
      case 'Sources':
        this.setState({ sourceInformation: data })
        const { errorSources } = this.state
        const errorSourcesKeys = Object.keys(errorSources)
        if (errorSourcesKeys.length) {
          const returnValue = this.sourcesCheck(data)
          if (returnValue === 1) {
            const count = Array.from(this.state.count)
            count[10] = 1
            this.setState({ count: count })
          }
        }
        break
      case 'Policies':
        this.setState({ acceptedPolicies: data })
        break
      default:
        break
    }
  }

  toggleAccordion(index) {
    const { activeSections } = this.state
    const sectionsBody = []
    activeSections.forEach((section, i) => {
      if (i === index) {
        section.open = !section.open
      } else {
        section.open = false
      }
      sectionsBody.push(section)
    })
    this.setState({ activeSections: sectionsBody })
  }

  toggleAll() {
    const { activeSections } = this.state
    const sectionsBody = []
    activeSections.forEach((section, i) => {
      section.open = false
      sectionsBody.push(section)
    })
    this.setState({ activeSections: sectionsBody })
  }


  getDefaultValue(componentName, data) {
    switch (componentName) {
      case 'Add':
        this.setState({ address: { ...this.state.address, addressType: data } })
        break
      case 'Contact':
        if (this.state.contactInformations && this.state.contactInformations.phoneNumberArray && this.state.contactInformations.phoneNumberArray.length > 0) {
          const phoneNumberArray = this.state.contactInformations.phoneNumberArray
          const length = phoneNumberArray.length
          phoneNumberArray.forEach((element, i) => {
            if (i === length - 1) {
              element.phoneType = data
            }
          })
          this.setState({ contactInformations: { ...this.state.contactInformation, phoneNumberArray: phoneNumberArray } })
        }
        break
      case 'Parent':
        if (this.state.parentsInformation && this.state.parentsInformation.fatherPrefix && this.state.parentsInformation.motherPrefix) {
          this.setState({
            parentsInformation: {
              ...this.state.parentsInformation,
              fatherPrefix: data.fatherDefault,
              motherPrefix: data.motherDefault
            }
          })
        }
        break
      default:
        break
    }
  }

  async handleSave() {

    const {
      personalInformation,
      ai,
      governmentInformation,
      address,
      contactInformations,
      educationHistorys,
      sourceInformation
    } = this.state
    const ci = []
    if (contactInformations.phoneNumberArray && contactInformations.phoneNumberArray.length > 0) {
      contactInformations.phoneNumberArray.forEach(element => {
        ci.push({
          PhoneType: element.phoneType,
          CountryId: element.phoneCountry,
          Email: contactInformations.email,
          PhoneNumber: element.phoneNumber,
          IsPrimary: element.isPrimary
        })
      })
    }
    /* PG — Education History: built from pgEducationData (PGEducationHistory component).
       highSchoolSection  → first EducationHistory entry (stored in ApplicationEducation table).
       Bachelor data      → stored in individual UserDefined columns (PgBachelor* fields below). */
    const eh = []
    const errorCheck = ['', 0, null, undefined]
    const sources = []
    if (sourceInformation) {
      if (sourceInformation.selectedSources && sourceInformation.selectedSources.length > 0) {
        sourceInformation.selectedSources.forEach(element => {
          sources.push({
            SourceId: element
          })
        })
      }
    }
    /* PG: no legacy test scores loop needed — English tests constructed in fetchBody below */
    // eslint-disable-next-line no-unused-vars
    const { militaryStatus, pgEducationData, pgEmergencyContact,
      taughtInEnglish, pgEnglishTests, hasProfExam, profExams,
      pgEmploymentData, maritalStatus, academicSupport, academicSupportDetails } = this.state

    /* PG — High School section → EducationHistory array */
    const pgEd = pgEducationData || {}
    const hs = pgEd.highSchoolSection || {}
    if (hs.highSchoolCertificate || hs.highSchoolName || hs.endDate) {
      eh.push({
        CurriculumId:    hs.highSchoolCertificate || 0,
        EndDate:         hs.endDate               || null,
        InstitutionId:   hs.highSchoolName        || '',
        InstitutionName: hs.institutionName       || '',
        CountryId:       hs.selectedCountry       || 0,
        CityId:          hs.selectedCity          || '',
        GPA:             0,
        EducationGrade:  hs.educationGrade        || ''
      })
    }
    const fetchBody = {
      IncompleteApplicationId: this.props.incompleteApplicationId || sessionStorage.getItem('id'),
      // Personal Information
      FirstName: personalInformation.fName || '',
      MiddleName: personalInformation.mName || '',
      LastName: personalInformation.lName || '',
      DateOfBirth: personalInformation.dateOfBirth || '',
      CountryOfBirth: personalInformation.selectedCountry || '',
      Nationality: personalInformation.selectedNationality || '',
      Gender: personalInformation.selectedGender || '',
      SiblingFName: personalInformation.siblingFName || '',
      SiblingMName: personalInformation.siblingMName || '',
      SiblingLName: personalInformation.siblingLName || '',
      SiblingTKHNumber: personalInformation.siblingTKHNumber || '',
      ArabicData: [
        {
          ColumnName: 'ARABIC_FIRSTNAME',
          ColumnValue: personalInformation.arabicText1 || ''
        },
        {
          ColumnName: 'ARABIC_MIDDLENAME',
          ColumnValue: personalInformation.arabicText2 || ''
        },
        {
          ColumnName: 'ARABIC_LASTNAME',
          ColumnValue: personalInformation.arabicText3 || ''
        }
      ],
      // PG — Military Status (Egyptian males)
      MilitaryStatus: militaryStatus || '',
      // Program of Study
      UniversityId: ai.selectedUniversity || '',
      SecondUniversityId: ai.selectedSecondUniversity || '',
      SecondProgramId: ai.selectedSecondProgram || '',
      SecondMajorId: ai.selectedSecondMajor || '',
      Level: ai.selectedLevel || '',
      SecondLevel: ai.selectedSecondLevel || '',
      ProgramOfStudyId: ai.selectedMajor || '',
      Description: ai.description || '',
      SecDescription: ai.secondDescription || '',
      EntryTerm: ai.selectedEntryTerm || '',
      ProgramId: ai.selectedProgram || '',
      PreferredCampus: ai.preferredCampus || '',
      // PG — School / Faculty selected in Program of Study
      PgSchoolName: ai.selectedSchool || '',
      // Government Information
      nationalIdNumber: governmentInformation.nationalNumber || '',
      passportNumber: governmentInformation.passportNumber || '',
      passportCountryIssued: governmentInformation.passportCountry || '',
      passportExpirationDate: governmentInformation.passportExpiryDate || '',
      // Address
      AddressTypeId: address.addressType || '',
      Line1: address.addressLine1 || '',
      Line2: address.addressLine2 || '',
      Country: parseInt(address.selectedCountry) || 0,
      City: parseInt(address.selectedCity) || 0,
      StateProvinceId: parseInt(address.selectedRegion) || 0,
      DormPlanInterest: address.dormPlanInterest,
      // Contact
      ContactInformation: ci.length > 0 ? ci : null,
      // PG — Emergency Contact
      PgEmergencyContactRelationship: pgEmergencyContact.relationship || '',
      PgEmergencyContactGivenName: pgEmergencyContact.givenName || '',
      PgEmergencyContactMiddleName: pgEmergencyContact.middleName || '',
      PgEmergencyContactFamilyName: pgEmergencyContact.familyName || '',
      PgEmergencyContactMobile: pgEmergencyContact.mobileNumber || '',
      PgEmergencyContactEmail: pgEmergencyContact.emailAddress || '',
      // PG — Coventry section
      CovAlumni: pgEducationData.covGraduate || '',
      CoventryId: pgEducationData.coventryId || '',
      // PG — Bachelor Degree (individual USERDEFINEDIND columns, NOT a JSON blob)
      PgBachelorUniversity:     pgEd.bachelorUniversity     || '',
      PgBachelorUniversityName: pgEd.bachelorUniversityName || '',
      PgBachelorDegree:         pgEd.bachelorDegree         || '',
      PgBachelorFieldOfStudy:   pgEd.bachelorFieldOfStudy   || '',
      PgBachelorYearOfGrad:     pgEd.bachelorYearOfGrad     || '',
      PgHasAcademicAward:       pgEd.hasAcademicAward       || '',
      PgAcademicAwards: (pgEd.academicAwards && pgEd.academicAwards.length > 0)
        ? JSON.stringify(pgEd.academicAwards)
        : '',
      PgProfExamsData:          JSON.stringify(profExams || []),
      AcademicAwards: (pgEd.academicAwards && pgEd.academicAwards.length > 0)
        ? JSON.stringify(pgEd.academicAwards)
        : '',
      // PG — Education: High School section stored in EducationHistory table
      EducationHistory: eh.length > 0 ? eh : null,
      // PG — English Proficiency
      BachelorTaughtInEnglish: taughtInEnglish === 'Yes',
      // Tests (English proficiency test scores)
      Tests: (taughtInEnglish === 'No' && pgEnglishTests && pgEnglishTests.length > 0)
        ? pgEnglishTests.filter(t => t.test && t.score && t.dateTaken).map(t => ({
            Test: t.test,
            TestType: t.testType || t.test,
            Score: t.score,
            DateTaken: t.dateTaken
          }))
        : null,
      // PG — Professional Examinations (flag only; details in PgProfExamsData above)
      HasProfExam: hasProfExam || false,
      // PG — Employment
      EmploymentStatus: pgEmploymentData.employmentStatus || '',
      EmployerCompanyName: pgEmploymentData.companyName || '',
      EmployerPosition: pgEmploymentData.position || '',
      EmployerStartDate: pgEmploymentData.startDate || '',
      EmployerDuties: pgEmploymentData.briefOfDuties || '',
      EmployerIdNumber: pgEmploymentData.employerIdNumber || '',
      // PG — Marital Status
      MaritalStatus: maritalStatus || '',
      AcademicSupport: academicSupport || '',
      AcademicSupportDetails: academicSupportDetails || '',
      // Source Information
      SourceInformation: sources.length > 0 ? sources : null,
      OtherSource: sourceInformation ? sourceInformation.otherSource : null
    }

    return fetch(`${process.env.REACT_APP_API_URL}/api/Save/SaveApplication`, {
      method: 'POST',
      body: JSON.stringify(fetchBody),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => res.json())
      .then(res => {
        if (res.StatusCode === 200) {
          this.setState({ saveProcessing: false })
          sessionStorage.setItem('isBlocking', false)
          return 1
        } else {
          this.setState({ saveProcessing: false })
          this.setState({ policyError: 'Some Error Occured!', color: 'red' })
          return 0
        }
      })
      .catch(err => {
        this.setState({ saveProcessing: false })
        console.log(err)
        this.setState({ policyError: 'Some Error Occured', color: 'red' })
      })
  }

  async submit() {
    this.setState({ nextProcessing: true })
    return fetch(`${process.env.REACT_APP_API_URL}/api/Validate/ValidateApplication`, {
      method: 'POST',
      body: JSON.stringify({ IncompleteApplicationId: this.props.incompleteApplicationId || sessionStorage.getItem('id') }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => res.json())
      .then(res => {
        if (res.StatusCode === 200) {
          this.props.onSubmit()
          this.setState({ nextProcessing: false })
        } else if (res.StatusCode === 404) {
          this.setState({ nextProcessing: false })
          const error = []
          if (res.Msg.ProgramOfStudyId || res.Msg.ProgramId) {
            this.setState({
              errorAI: {
                selectedMajor: res.Msg.ProgramOfStudyId ? 'Please check this value' : null,
                selectedProgram: res.Msg.ProgramId ? 'Please check this value' : null
              }
            })
            error.push('Program of Study')
          }
          if (res.Msg.GovernmentId) {
            this.setState({ errorGI: { nationalNumber: 'Please Enter the value' } })
            error.push('Official Identification')
          }


          if (res.Msg.AddressTypeId) {
            this.setState({ errorAdd: { addressType: 'Please select a value' } })
            error.push('Address')
          }

          if (res.Msg.TestType) {
            this.setState({ errorTest: { TestType: 'Please select all test type for the selected test' } })
            error.push('English Proficiency Assessment : ')
          }

          if (res.Msg.ExistsTestType) {
            this.setState({ testTypeError: `English Proficiency Assessment :` + res.Msg.ExistsTestType, color: 'red' })
          }
          this.setState({ policyError: `${error.join(', ')} Please enter all test type for the choosen test(s).`, color: 'red' })
          // this.setState({ policyError: `${error.join(', ')} section(s) have error(s) in them.`, color: 'red' })
          this.conditionCheck();
        }
      })
      .catch(err => {
        this.setState({ nextProcessing: false })
        console.log(err)
      })
  }

  render() {
    const { error, policyError, testTypeError, loading, color, acceptedPolicies, saved, activeSections, count, saveProcessing, nextProcessing, isPopup, showUploadPage, nationality, taughtInEnglish, hasProfExam, pgEmploymentData, covAlumni, incompleteApplicationId } = this.state
    if (loading) {
      return (
        <div id="mainContainer">
          <div id="designBorder">

            <div id="main-page" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <img src={loader} style={{
                justifyContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto'
              }} alt="Loading..." />
            </div>
          </div>

        </div>
      )
    }
    if (error) {
      return (
        <div id="mainContainer">
          <div id="designBorder">

            <div id="main-page">
              <p style={{ color: 'red', maxWidth: 'calc(100% - 150px)' }}>{error}</p>
              <button
                className="save"
                onClick={() =>
                  this.props.onClick()

                }
                id="logout-button"
              >Logout</button>
            </div>
          </div>
        </div>
      )
    }
    // ── Upload Documents separate page (shown after Next is clicked) ──
    if (showUploadPage) {
      return (
        <PGUploadDocuments
          incompleteApplicationId={incompleteApplicationId}
          token={this.state.token}
          onClick={this.props.onClick}
          taughtInEnglish={taughtInEnglish || ''}
          covAlumni={covAlumni || ''}
          hasProfExam={hasProfExam || false}
          nationality={nationality || 0}
          employmentStatus={(pgEmploymentData && pgEmploymentData.employmentStatus) || ''}
        />
      )
    }

    const accordionSections = []
    activeSections.forEach((element, i) => {
      accordionSections.push(
        <div key={i}>
          <div
            className={'accordion ' + (element.open ? 'open' : '')}
            key={i}
          >
            <div className="accordionSectionHeader" onClick={() => this.toggleAccordion(i)}>
              <span className="accordionSectionHeaderContent" style={count[i] === 0 ? { backgroundColor: 'white', color: 'red', borderWidth: 1, borderColor: 'red', borderStyle: 'solid', boxSizing: 'border-box' } : null}>{count[i] === 0 ? '!' : `${i + 1}`}</span>
              <span className="acc-heading" style={count[i] === 0 ? { color: 'red' } : null}>{element.name}</span>
            </div>
            <div className="accordion-form">
              {this.getActiveTabBody(i)}
            </div>
          </div>
        </div>
      )
    })
    return (
      <>
        {saved 
          ? <div className="alert-box">
            <div className="alert-box-header">
              <p>Application Saved</p>
              <p onClick={() => this.setState({ saved: false })} style={{ cursor: 'pointer' }}>X</p>
            </div>
            <div className="alert-box-body">
              <p>Your application has been saved</p>
            </div>
            <div className="alert-box-footer">
              <button className="save" onClick={() => {
                this.setState({ saved: true })
                this.props.onClick()
              }}>Ok</button>
            </div>
          </div>
          : null}
        { isPopup 
          ? <div className="alert-box-discliamer">
            <div className="alert-box-header">
              <p>Please Read the Below Disclaimers</p>
              <p onClick={() => {this.setState({ isPopup: false })
            }
            } style={{ cursor: 'pointer' }}>X</p>
              
            </div>
            <div className="alert-box-body">
                <p>o Please note that TKH New Zayed Campus <b>is due to</b> operate starting the second semester of 23/24 Academic Year.<br/>o Students joining the New Zayed Campus will attend the first semester of the 23/24 Academic Year in The New Administrative Capital’s Campus and the second semester at The New Zayed Campus.</p>
            </div>
            <div className="alert-box-footer">
              <button className="save" onClick={() => {
                this.setState({ isPopup: false })
              }}>Ok</button>
            </div>
          </div>
          : null}
        <div id={saved || isPopup ? 'mainContainer-blur' : 'mainContainer'}>

          <div id='designBorder'>
            <img src={logo} className="center main-logo"></img>
            <div id='main-page'>
              <div id="applicationForm">

                  <h4 className='app-heading'>Postgraduate Application Form</h4>
                <button
                  className="save"
                  onClick={() => {
                    sessionStorage.setItem('isBlocking', false)
                    this.props.onClick()
                  }}
                  id="logout-button"
                >Logout</button>
                <div id="header">
                  <p style={{ fontWeight: 'bold' }}>Application Instructions:</p>
                  <p style={{ marginBottom: 10 }}>Please read the instructions carefully before starting your application.</p>

                  <p className='main-content-list'>• Please note that you can save your application and return to complete it later. Once your application is submitted, no further edits or changes can be made.</p>

                  <p className='main-content-list'>• The email address and mobile number used to create your account will be used for all official communication. Please ensure they are correct.</p>

                  <p className='main-content-list'>• The Admissions Committee will conduct an initial screening and may contact you before the interview stage if additional requirements are needed.</p>

                  <p className='main-content-list'>• An application fee (<strong>1,500 EGP</strong>) must be paid online at the time of submission.</p>

                  <p className='main-content-list'>• Meeting the minimum entry requirements does not guarantee admission; all applications are assessed holistically.</p>

                  <p className='main-content-list'>• Shortlisted applicants will be invited for an interview as part of the assessment process.</p>

                  <p className='main-content-list'>• Applicants will be officially notified once the evaluation process is completed.</p>

                  <p className='main-content-list'>• Please ensure you have reviewed all TKH Online Application Guidelines before submitting.</p>

                  <p style={{ color: 'red', marginTop: 12 }}>* Required Field</p>
                  <p style={{ color: 'red' }}>** Please answer in the same language as the field question</p>

                </div>
              </div>
              <br />
              {policyError && <p style={{ color: color }}>{policyError}</p>}
              {testTypeError && <p style={{ color: color }}>{testTypeError}</p>}
              {accordionSections}
              <div className="main-button">
                <button className="save" onClick={() => {
                  this.setState({ saveProcessing: true, policyError: '', testTypeError: '' })
                  this.handleSave()
                    .then(res => {
                      if (res === 1) {
                        this.setState({ saved: true })
                      }
                    })
                }}
                  disabled={saveProcessing || nextProcessing}
                >
                  {saveProcessing ? <img src={submit} alt="Loading..." style={{ width: 18, height: 18 }} /> : 'Save and Exit'}
                </button>
                <button className="save" onClick={() => {
                  this.setState({ nextProcessing: true, policyError: '', testTypeError: '' })
                  const count = this.conditionCheck()
                  if (count.indexOf(0) === -1) {
                    this.handleSave()
                      .then(res => {
                        if (res === 1) {
                          this.setState({ showUploadPage: true, nextProcessing: false })
                        } else {
                          this.setState({ nextProcessing: false })
                        }
                      })
                  } else {
                    this.setState({ nextProcessing: false })
                  }
                }} disabled={!acceptedPolicies || nextProcessing || saveProcessing}>
                  {nextProcessing ? <img src={submit} alt="Loading..." style={{ width: 18, height: 18 }} /> : 'Next'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
Mains.propTypes = {
  incompleteApplicationId: PropTypes.number,
  token: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  history: PropTypes.object
}
